import {chakra} from '@chakra-ui/react'

const Logo = () => {
  return (
    <chakra.svg
      filter="drop-shadow(1px 2px 2px rgb(0 0 0 / 0.1))"
      xmlns="http://www.w3.org/2000/svg"
      width="full"
      height="full"
      viewBox="0 0 755.90668 377.94666">
      <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,377.94667)">
        <g id="g12" transform="scale(0.1)">
          <path
            d="m 760.539,1666.21 c 1.543,-3.99 1.531,-8.57 -0.422,-12.77 -1.469,-3.13 -3.765,-5.55 -6.539,-7.15 -4.426,-2.55 -9.949,-2.98 -14.922,-0.67 -3.136,1.46 -5.547,3.78 -7.152,6.55 -2.555,4.44 -2.977,9.95 -0.641,14.91 l -9.199,4.32 c -3.816,-8.08 -3.121,-17.14 1.024,-24.32 2.605,-4.51 6.601,-8.32 11.671,-10.68 8.086,-3.75 17.129,-3.08 24.301,1.08 l 0.008,0.01 c 4.512,2.6 8.301,6.59 10.684,11.65 3.148,6.8 3.187,14.28 0.671,20.75 l -9.484,-3.68"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path14"
          />
          <path
            d="m 779.668,1712.92 c 0.605,-4.24 -0.441,-8.71 -3.281,-12.36 -2.137,-2.72 -4.922,-4.55 -7.989,-5.49 -4.878,-1.49 -10.359,-0.67 -14.683,2.7 -2.731,2.13 -4.559,4.93 -5.496,8 -1.492,4.89 -0.66,10.36 2.726,14.66 l -7.984,6.29 c -5.539,-7.02 -6.902,-16 -4.477,-23.93 1.52,-4.98 4.563,-9.59 8.965,-13.03 7.035,-5.48 16,-6.86 23.926,-4.42 l 0.008,0.01 c 4.98,1.52 9.574,4.55 13.031,8.95 4.598,5.91 6.32,13.2 5.324,20.06 l -10.07,-1.44"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path16"
          />
          <path
            d="m 806.352,1745 c -2.692,-2.17 -5.817,-3.33 -9.016,-3.56 -5.09,-0.35 -10.242,1.69 -13.699,5.95 -2.184,2.69 -3.328,5.82 -3.559,9.02 -0.351,5.11 1.688,10.25 5.957,13.68 l -6.367,7.92 c -6.977,-5.59 -10.324,-14.04 -9.742,-22.31 0.359,-5.19 2.289,-10.37 5.804,-14.72 5.622,-6.91 14.047,-10.27 22.317,-9.68 h 0.016 c 5.187,0.37 10.343,2.29 14.703,5.8 5.808,4.72 9.129,11.44 9.703,18.35 l -10.141,0.85 c -0.363,-4.26 -2.383,-8.38 -5.976,-11.3"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path18"
          />
          <path
            d="m 839.266,1783.1 c -3.11,-1.51 -6.418,-1.94 -9.586,-1.44 -5.039,0.8 -9.602,3.95 -12.012,8.88 -1.52,3.1 -1.934,6.42 -1.434,9.59 0.805,5.05 3.95,9.6 8.879,11.98 l -4.425,9.16 c -8.051,-3.89 -13.215,-11.36 -14.512,-19.55 -0.813,-5.14 -0.102,-10.62 2.347,-15.65 3.926,-8 11.379,-13.17 19.571,-14.45 h 0.011 c 5.141,-0.82 10.598,-0.11 15.633,2.34 6.723,3.29 11.465,9.09 13.582,15.7 l -9.687,3.11 c -1.313,-4.08 -4.207,-7.63 -8.367,-9.67"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path20"
          />
          <path
            d="m 880.195,1814.65 c -3.375,-0.77 -6.691,-0.45 -9.664,0.76 -4.73,1.91 -8.468,6 -9.711,11.34 -0.781,3.38 -0.437,6.7 0.766,9.67 1.91,4.74 6.004,8.47 11.344,9.69 l -2.25,9.91 c -8.723,-1.97 -15.434,-8.1 -18.535,-15.78 -1.954,-4.83 -2.493,-10.33 -1.239,-15.78 2.028,-8.68 8.125,-15.39 15.817,-18.49 h 0.011 c 4.825,-1.95 10.301,-2.48 15.758,-1.24 7.297,1.7 13.219,6.28 16.77,12.24 l -8.742,5.21 c -2.2,-3.67 -5.821,-6.48 -10.325,-7.53"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path22"
          />
          <path
            d="m 924.969,1837.49 c -3.457,0.01 -6.617,1.07 -9.242,2.91 -4.184,2.93 -6.903,7.76 -6.911,13.24 -0.003,3.46 1.082,6.62 2.914,9.25 2.938,4.19 7.758,6.9 13.239,6.88 l 0.035,10.17 c -8.938,0.04 -16.859,-4.42 -21.613,-11.21 -2.985,-4.26 -4.75,-9.5 -4.75,-15.09 0.019,-8.91 4.453,-16.82 11.254,-21.57 l 0.007,-0.01 c 4.262,-2.98 9.481,-4.73 15.078,-4.75 7.489,0.02 14.293,3.15 19.09,8.16 l -7.34,7.04 c -2.968,-3.08 -7.132,-5.01 -11.761,-5.02"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path24"
          />
          <path
            d="m 971.168,1853.39 c -3.367,0.79 -6.207,2.53 -8.352,4.91 -3.414,3.8 -4.976,9.11 -3.753,14.46 0.777,3.37 2.542,6.21 4.921,8.35 3.805,3.43 9.11,4.99 14.446,3.73 l 2.32,9.9 c -8.699,2.05 -17.414,-0.51 -23.578,-6.06 -3.867,-3.48 -6.766,-8.19 -8.024,-13.63 -1.984,-8.69 0.555,-17.4 6.114,-23.55 l 0.008,-0.01 c 3.48,-3.87 8.168,-6.75 13.617,-8.02 7.304,-1.67 14.633,-0.15 20.437,3.66 l -5.566,8.51 c -3.59,-2.34 -8.074,-3.28 -12.59,-2.25"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path26"
          />
          <path
            d="m 1317.22,1646.29 c -2.77,1.6 -5.07,4.02 -6.54,7.14 -1.95,4.2 -1.96,8.79 -0.42,12.78 l -9.49,3.68 c -2.51,-6.47 -2.47,-13.95 0.68,-20.75 2.37,-5.06 6.17,-9.05 10.67,-11.66 h 0.02 c 7.17,-4.15 16.21,-4.83 24.3,-1.08 5.06,2.36 9.07,6.17 11.67,10.68 4.15,7.18 4.84,16.24 1.02,24.33 l -9.19,-4.33 c 2.33,-4.96 1.91,-10.47 -0.65,-14.91 -1.6,-2.77 -4.01,-5.09 -7.15,-6.55 -4.98,-2.31 -10.5,-1.88 -14.92,0.67"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path28"
          />
          <path
            d="m 1294.41,1700.56 c -2.84,3.65 -3.88,8.12 -3.28,12.36 l -10.07,1.44 c -1,-6.86 0.73,-14.15 5.32,-20.06 3.46,-4.4 8.05,-7.43 13.03,-8.95 l 0.01,-0.01 c 7.93,-2.43 16.89,-1.05 23.93,4.42 4.4,3.44 7.44,8.05 8.96,13.03 2.43,7.93 1.07,16.91 -4.47,23.93 l -7.99,-6.29 c 3.39,-4.3 4.22,-9.77 2.73,-14.66 -0.94,-3.07 -2.77,-5.86 -5.5,-8 -4.32,-3.36 -9.8,-4.2 -14.69,-2.7 -3.06,0.94 -5.84,2.77 -7.98,5.49"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path30"
          />
          <path
            d="m 1258.47,1756.3 -10.14,-0.85 c 0.57,-6.92 3.89,-13.63 9.7,-18.35 4.36,-3.51 9.52,-5.44 14.71,-5.8 h 0.01 c 8.27,-0.59 16.69,2.77 22.32,9.68 3.51,4.35 5.44,9.53 5.8,14.72 0.58,8.27 -2.77,16.72 -9.74,22.31 l -6.37,-7.92 c 4.27,-3.43 6.31,-8.58 5.96,-13.68 -0.23,-3.19 -1.38,-6.33 -3.56,-9.02 -3.46,-4.26 -8.61,-6.3 -13.7,-5.94 -3.2,0.22 -6.32,1.39 -9.02,3.55 -3.59,2.92 -5.61,7.04 -5.97,11.3"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path32"
          />
          <path
            d="m 1242.69,1771.62 h 0.02 c 8.19,1.29 15.64,6.45 19.56,14.45 2.45,5.03 3.16,10.51 2.35,15.65 -1.3,8.19 -6.46,15.67 -14.52,19.55 l -4.42,-9.16 c 4.94,-2.38 8.08,-6.93 8.88,-11.98 0.5,-3.17 0.09,-6.49 -1.43,-9.59 -2.41,-4.93 -6.97,-8.08 -12.01,-8.88 -3.17,-0.5 -6.48,-0.07 -9.59,1.44 -4.16,2.04 -7.05,5.59 -8.36,9.67 l -9.7,-3.12 c 2.12,-6.6 6.86,-12.4 13.59,-15.7 5.04,-2.44 10.49,-3.15 15.63,-2.33"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path34"
          />
          <path
            d="m 1218.65,1840.23 c -3.1,7.69 -9.81,13.81 -18.53,15.79 l -2.25,-9.92 c 5.34,-1.21 9.43,-4.94 11.34,-9.68 1.2,-2.97 1.54,-6.3 0.77,-9.67 -1.25,-5.34 -4.98,-9.44 -9.72,-11.35 -2.97,-1.2 -6.29,-1.52 -9.66,-0.75 -4.51,1.05 -8.13,3.86 -10.33,7.53 l -8.73,-5.21 c 3.55,-5.96 9.47,-10.54 16.76,-12.24 5.46,-1.25 10.93,-0.71 15.76,1.24 l 0.02,0.01 c 7.68,3.09 13.78,9.8 15.81,18.48 1.26,5.45 0.72,10.95 -1.24,15.77"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path36"
          />
          <path
            d="m 1167.4,1868.73 c -4.75,6.79 -12.67,11.25 -21.61,11.21 l 0.04,-10.17 c 5.48,0.02 10.3,-2.69 13.23,-6.88 1.84,-2.63 2.92,-5.79 2.92,-9.25 -0.01,-5.48 -2.73,-10.31 -6.91,-13.24 -2.63,-1.84 -5.78,-2.9 -9.24,-2.91 -4.63,0.01 -8.79,1.94 -11.76,5.02 l -7.34,-7.04 c 4.8,-5.02 11.6,-8.14 19.09,-8.16 5.59,0.02 10.81,1.77 15.07,4.75 l 0.01,0.01 c 6.8,4.75 11.24,12.66 11.26,21.57 0,5.59 -1.77,10.83 -4.76,15.09"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path38"
          />
          <path
            d="m 1113.63,1888.68 c -6.16,5.55 -14.89,8.11 -23.58,6.06 l 2.32,-9.89 c 5.33,1.24 10.64,-0.31 14.44,-3.73 2.38,-2.15 4.15,-4.98 4.93,-8.36 1.22,-5.35 -0.34,-10.66 -3.76,-14.46 -2.14,-2.38 -4.99,-4.12 -8.35,-4.91 -4.52,-1.03 -9,-0.09 -12.59,2.25 l -5.57,-8.52 c 5.8,-3.8 13.14,-5.32 20.44,-3.65 5.45,1.27 10.14,4.15 13.62,8.02 l 0.01,0.01 c 5.55,6.15 8.09,14.86 6.11,23.55 -1.26,5.45 -4.15,10.15 -8.02,13.63"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path40"
          />
          <path
            d="m 1035.4,2091.07 c -372.42,0 -675.4,-302.98 -675.4,-675.4 0,-372.41 302.98,-675.4 675.4,-675.4 372.41,0 675.4,302.99 675.4,675.4 0,372.42 -302.99,675.4 -675.4,675.4 m 0,-1330.211 c -361.068,0 -654.814,293.751 -654.814,654.811 0,361.07 293.746,654.81 654.814,654.81 361.06,0 654.81,-293.74 654.81,-654.81 0,-361.06 -293.75,-654.811 -654.81,-654.811"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path42"
          />
          <path
            d="m 731.098,1370.82 -0.024,0.04 -26.027,-45.08 h 52.105 l -26.035,45.08 z m -16.735,-39.69 16.735,28.99 16.738,-28.99 z"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path44"
          />
          <path
            d="m 731.098,1273.23 c 0.125,-0.01 0.242,-0.03 0.363,-0.03 12.543,0 22.75,10.21 22.75,22.75 0,12.54 -10.207,22.75 -22.75,22.75 -0.121,0 -0.238,-0.01 -0.363,-0.02 -0.121,0.01 -0.243,0.02 -0.364,0.02 -12.543,0 -22.746,-10.21 -22.746,-22.75 0,-12.54 10.203,-22.75 22.746,-22.75 0.121,0 0.243,0.02 0.364,0.03 m -17.032,22.72 c 0,9.47 7.614,17.16 17.032,17.36 9.422,-0.2 17.035,-7.89 17.035,-17.36 0,-9.46 -7.613,-17.16 -17.035,-17.35 -9.418,0.19 -17.032,7.89 -17.032,17.35"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path46"
          />
          <path
            d="m 920.887,1958.11 c 11.918,0 23.265,6.69 29.375,12.1 l -5.461,6.17 c -0.918,-0.81 -22.621,-19.6 -38.922,-3.73 -5.211,5.07 -7.078,13.92 -4.645,22.01 2.789,9.31 10.473,15.8 21.079,17.82 19.511,3.73 35.734,-9.38 52.921,-23.25 3.93,-3.18 8,-6.46 12.043,-9.46 17.423,-12.93 37.763,-13.03 48.123,-13.03 10.37,0 30.68,0.09 48.12,13.03 4.04,3 8.11,6.28 12.03,9.45 17.19,13.88 33.46,26.97 52.94,23.26 10.59,-2.02 18.28,-8.51 21.07,-17.82 2.44,-8.09 0.57,-16.94 -4.64,-22.01 -16.3,-15.86 -38.01,2.92 -38.92,3.73 l -5.47,-6.17 c 6.11,-5.41 17.46,-12.1 29.38,-12.1 7.04,0 14.27,2.33 20.75,8.64 7.47,7.27 10.13,19.15 6.79,30.29 -3.71,12.34 -13.71,20.92 -27.42,23.53 -23.29,4.44 -41.76,-10.5 -59.65,-24.94 -3.86,-3.12 -7.86,-6.34 -11.76,-9.24 -8.49,-6.3 -18.28,-9.14 -26.72,-10.37 8.4,6.52 13.66,15.86 14.52,26.69 0.97,12.4 -4.4,23.75 -13.69,28.93 -9.34,5.2 -18.43,6.47 -27.04,3.76 -15.44,-4.84 -23.38,-20.79 -23.71,-21.46 l 7.41,-3.62 c 0.06,0.14 6.67,13.43 18.77,17.23 6.37,2 13.29,0.95 20.56,-3.1 6.49,-3.62 10.21,-11.9 9.49,-21.09 -0.94,-11.91 -8.7,-21.66 -20.76,-26.07 -2.92,-1.08 -5.32,-1.93 -9,-2.14 -9.62,0.25 -24.24,2.31 -36.27,11.24 -3.91,2.9 -7.907,6.12 -11.778,9.24 -17.886,14.44 -36.394,29.37 -59.636,24.94 -13.715,-2.61 -23.711,-11.19 -27.418,-23.53 -3.344,-11.14 -0.68,-23.02 6.793,-30.29 6.472,-6.31 13.707,-8.64 20.746,-8.64"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path48"
          />
          <path
            d="m 643.105,1040.41 c -1.613,4.67 -6.75,7.13 -11.421,5.56 -4.653,-1.64 -7.18,-6.77 -5.555,-11.41 1.594,-4.55 6.75,-7.18 11.422,-5.59 4.66,1.61 7.129,6.88 5.554,11.44"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path50"
          />
          <path
            d="m 581.273,993.762 c -4.652,-1.641 -7.175,-6.774 -5.554,-11.41 1.594,-4.543 6.75,-7.18 11.422,-5.59 4.66,1.609 7.129,6.879 5.554,11.437 -1.613,4.672 -6.75,7.129 -11.422,5.563"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path52"
          />
          <path
            d="m 621.145,985.328 c -4.735,0.891 -9.59,-2.25 -10.547,-7.098 -0.938,-4.832 2.386,-9.609 7.129,-10.531 4.847,-0.929 9.543,2.289 10.519,7.121 0.91,4.84 -2.269,9.602 -7.101,10.508"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path54"
          />
          <path
            d="m 590.586,1048 c -0.941,-4.85 2.391,-9.61 7.129,-10.53 4.848,-0.94 9.543,2.28 10.519,7.11 0.911,4.85 -2.269,9.6 -7.101,10.51 -4.731,0.9 -9.59,-2.25 -10.547,-7.09"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path56"
          />
          <path
            d="m 580.133,1026.95 c -3.727,3.23 -9.52,2.73 -12.688,-0.91 -3.23,-3.74 -2.797,-9.41 0.903,-12.67 3.742,-3.21 9.449,-2.83 12.656,0.89 3.141,3.66 2.84,9.43 -0.871,12.69"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path58"
          />
          <path
            d="m 637.867,1008.49 c -3.23,-3.74 -2.801,-9.412 0.903,-12.67 3.742,-3.211 9.445,-2.832 12.656,0.891 3.14,3.659 2.844,9.429 -0.871,12.689 -3.723,3.23 -9.524,2.73 -12.688,-0.91"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path60"
          />
          <path
            d="m 592.484,1028.3 c -9.265,-9.29 -9.25,-24.37 0.032,-33.628 9.285,-9.262 24.363,-9.25 33.629,0.027 9.257,9.281 9.242,24.371 -0.036,33.631 -9.281,9.26 -24.367,9.25 -33.625,-0.03 m 29.868,-29.82 c -7.172,-7.179 -18.864,-7.199 -26.051,-0.019 -7.196,7.169 -7.203,18.859 -0.028,26.049 7.172,7.19 18.864,7.21 26.055,0.03 7.195,-7.18 7.203,-18.87 0.024,-26.06"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path62"
          />
          <path
            d="m 717.637,970.809 c -4.231,-2.528 -5.676,-8.071 -3.16,-12.289 2.472,-4.129 8.05,-5.68 12.312,-3.18 4.238,2.5 5.602,8.16 3.149,12.32 -2.516,4.238 -8.036,5.629 -12.301,3.149"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path64"
          />
          <path
            d="m 678.695,909.559 c -4.226,-2.528 -5.675,-8.059 -3.156,-12.278 2.473,-4.133 8.047,-5.679 12.313,-3.191 4.238,2.512 5.601,8.172 3.144,12.32 -2.512,4.25 -8.031,5.629 -12.301,3.149"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path66"
          />
          <path
            d="m 719.445,909.289 c -4.812,-0.07 -8.941,-4.129 -8.914,-9.07 0.051,-4.918 4.274,-8.938 9.098,-8.879 4.934,0.051 8.894,4.14 8.879,9.082 -0.078,4.918 -4.141,8.937 -9.063,8.867"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path68"
          />
          <path
            d="m 676.965,964.57 c 0.047,-4.929 4.265,-8.941 9.09,-8.89 4.941,0.058 8.894,4.148 8.883,9.082 -0.079,4.929 -4.145,8.937 -9.063,8.879 -4.812,-0.082 -8.941,-4.129 -8.91,-9.071"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path70"
          />
          <path
            d="m 670.934,941.859 c -4.289,2.422 -9.875,0.762 -12.246,-3.429 -2.422,-4.309 -0.86,-9.782 3.421,-12.231 4.309,-2.398 9.821,-0.89 12.215,3.403 2.348,4.207 0.899,9.808 -3.39,12.257"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path72"
          />
          <path
            d="m 743.441,938.762 c -4.289,2.418 -9.871,0.769 -12.242,-3.434 -2.422,-4.308 -0.863,-9.777 3.418,-12.226 4.309,-2.403 9.821,-0.891 12.219,3.41 2.348,4.199 0.898,9.797 -3.395,12.25"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path74"
          />
          <path
            d="m 722.473,919.469 c 7.215,10.953 4.175,25.722 -6.766,32.941 -10.949,7.211 -25.727,4.192 -32.941,-6.762 -7.219,-10.949 -4.18,-25.718 6.765,-32.937 10.946,-7.223 25.723,-4.18 32.942,6.758 m -29.996,-2.289 c -8.485,5.59 -10.832,17.039 -5.243,25.519 5.59,8.481 17.043,10.84 25.524,5.242 8.484,-5.589 10.832,-17.043 5.238,-25.523 -5.59,-8.477 -17.039,-10.84 -25.519,-5.238"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path76"
          />
          <path
            d="m 1444.66,1034.56 c 1.63,4.64 -0.9,9.77 -5.55,11.41 -4.67,1.57 -9.8,-0.89 -11.42,-5.56 -1.57,-4.56 0.9,-9.83 5.55,-11.44 4.68,-1.58 9.84,1.04 11.42,5.59"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path78"
          />
          <path
            d="m 1489.52,993.762 c -4.67,1.566 -9.8,-0.891 -11.42,-5.563 -1.57,-4.558 0.9,-9.828 5.56,-11.437 4.67,-1.59 9.82,1.047 11.42,5.59 1.62,4.636 -0.9,9.769 -5.56,11.41"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path80"
          />
          <path
            d="m 1449.65,985.328 c -4.83,-0.906 -8.01,-5.668 -7.1,-10.508 0.98,-4.832 5.67,-8.05 10.52,-7.121 4.74,0.922 8.07,5.699 7.13,10.531 -0.96,4.848 -5.82,7.989 -10.55,7.098"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path82"
          />
          <path
            d="m 1462.56,1044.58 c 0.98,-4.83 5.68,-8.05 10.52,-7.11 4.74,0.91 8.07,5.68 7.13,10.52 -0.96,4.85 -5.81,8 -10.55,7.1 -4.83,-0.91 -8.01,-5.66 -7.1,-10.51"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path84"
          />
          <path
            d="m 1490.67,1026.95 c -3.72,-3.26 -4.02,-9.03 -0.88,-12.69 3.21,-3.72 8.92,-4.1 12.66,-0.89 3.7,3.26 4.13,8.93 0.9,12.67 -3.16,3.64 -8.96,4.14 -12.68,0.91"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path86"
          />
          <path
            d="m 1420.24,1009.4 c -3.71,-3.26 -4.01,-9.04 -0.87,-12.689 3.21,-3.731 8.92,-4.102 12.66,-0.891 3.7,3.258 4.13,8.93 0.9,12.67 -3.17,3.64 -8.96,4.14 -12.69,0.91"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path88"
          />
          <path
            d="m 1478.31,1028.3 c -9.26,9.28 -24.34,9.29 -33.62,0.03 -9.28,-9.26 -9.3,-24.35 -0.04,-33.631 9.27,-9.277 24.35,-9.289 33.63,-0.027 9.28,9.258 9.3,24.338 0.03,33.628 m -29.87,-29.82 c -7.17,7.19 -7.17,18.88 0.03,26.06 7.19,7.18 18.87,7.16 26.05,-0.03 7.18,-7.19 7.17,-18.88 -0.02,-26.049 -7.19,-7.18 -18.88,-7.16 -26.06,0.019"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path90"
          />
          <path
            d="m 1340.86,967.648 c -2.46,-4.148 -1.09,-9.808 3.15,-12.308 4.26,-2.5 9.84,-0.949 12.31,3.18 2.52,4.23 1.07,9.761 -3.16,12.289 -4.27,2.48 -9.79,1.089 -12.3,-3.161"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path92"
          />
          <path
            d="m 1392.1,909.559 c -4.26,2.48 -9.79,1.101 -12.3,-3.149 -2.46,-4.148 -1.09,-9.808 3.15,-12.32 4.26,-2.488 9.84,-0.942 12.31,3.191 2.52,4.219 1.07,9.75 -3.16,12.278"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path94"
          />
          <path
            d="m 1351.35,909.289 c -4.92,0.07 -8.98,-3.949 -9.06,-8.867 -0.01,-4.942 3.94,-9.031 8.88,-9.082 4.82,-0.059 9.04,3.961 9.09,8.879 0.03,4.941 -4.1,9 -8.91,9.07"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path96"
          />
          <path
            d="m 1375.86,964.762 c -0.01,-4.934 3.94,-9.024 8.88,-9.082 4.82,-0.039 9.05,3.961 9.09,8.89 0.03,4.942 -4.1,8.989 -8.91,9.071 -4.92,0.07 -8.98,-3.961 -9.06,-8.879"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path98"
          />
          <path
            d="m 1399.86,941.859 c -4.29,-2.449 -5.73,-8.05 -3.39,-12.257 2.4,-4.293 7.91,-5.801 12.22,-3.403 4.28,2.449 5.84,7.922 3.42,12.231 -2.37,4.191 -7.96,5.851 -12.25,3.429"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path100"
          />
          <path
            d="m 1327.36,938.762 c -4.3,-2.453 -5.74,-8.051 -3.4,-12.25 2.4,-4.301 7.91,-5.813 12.22,-3.41 4.28,2.449 5.84,7.918 3.42,12.226 -2.37,4.203 -7.95,5.852 -12.24,3.434"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path102"
          />
          <path
            d="m 1388.03,945.648 c -7.22,10.954 -21.99,13.973 -32.94,6.762 -10.95,-7.219 -13.98,-21.988 -6.76,-32.941 7.21,-10.938 21.99,-13.981 32.94,-6.758 10.94,7.219 13.98,21.988 6.76,32.937 m -9.71,-28.468 c -8.48,-5.602 -19.93,-3.239 -25.52,5.238 -5.59,8.48 -3.25,19.934 5.24,25.523 8.48,5.598 19.93,3.239 25.52,-5.242 5.59,-8.48 3.24,-19.929 -5.24,-25.519"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path104"
          />
          <path
            d="m 637.746,1475.74 -3.18,-1.56 c -2.664,-1.31 -13.707,-6.88 -25.902,-14.77 -1.035,5.14 -3.195,12.97 -7.586,20.76 -3.547,6.31 -11.301,15.41 -14.992,19.6 2.785,4.61 9.516,14.93 19.207,24.62 13.34,13.34 29.125,22.69 29.285,22.78 l -4.176,7.1 c -0.679,-0.4 -16.828,-9.95 -30.929,-24.06 -13.809,-13.8 -21.743,-28.39 -22.075,-29 l -1.382,-2.57 1.964,-2.16 c 0.118,-0.13 11.735,-12.89 15.922,-20.34 5.067,-9.01 6.778,-18.27 7.282,-21.79 -15.668,-11.09 -30.84,-25.28 -30.84,-38.68 0,-13.41 15.176,-27.59 30.844,-38.68 -0.497,-3.51 -2.188,-12.73 -7.286,-21.79 -4.187,-7.45 -15.804,-20.22 -15.922,-20.35 l -1.964,-2.15 1.382,-2.57 c 0.332,-0.62 8.266,-15.21 22.075,-29.01 14.101,-14.11 30.25,-23.66 30.929,-24.06 l 4.172,7.11 c -0.156,0.08 -15.914,9.4 -29.281,22.77 -9.691,9.69 -16.422,20.01 -19.207,24.62 3.691,4.2 11.445,13.29 14.992,19.6 4.391,7.8 6.551,15.62 7.586,20.76 12.195,-7.89 23.238,-13.45 25.902,-14.76 l 3.196,-1.58 2.015,2.94 c 0.727,1.05 17.672,26.08 17.672,57.28 0,31.2 -16.961,55.99 -17.683,57.03 z m -18.172,-40.49 24.754,9.01 c 2.379,-7.16 4.32,-15.5 4.777,-24.47 H 621.34 v -8.24 h 27.758 c -0.485,-8.94 -2.45,-17.27 -4.84,-24.45 l -24.684,8.99 -2.816,-7.74 24.621,-8.96 c -2.426,-5.82 -4.879,-10.38 -6.508,-13.16 -18.363,9.53 -56.293,32.68 -56.293,49.44 0,16.74 37.957,39.91 56.317,49.44 1.636,-2.76 4.109,-7.31 6.546,-13.14 l -24.683,-8.98 2.816,-7.74"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path106"
          />
          <path
            d="m 1476.89,1355.2 c -5.07,9.01 -6.78,18.27 -7.28,21.79 15.67,11.09 30.84,25.28 30.84,38.68 0,13.4 -15.17,27.59 -30.84,38.68 0.49,3.5 2.19,12.72 7.28,21.79 4.19,7.45 15.81,20.21 15.92,20.34 l 1.97,2.16 -1.38,2.57 c -0.33,0.61 -8.26,15.2 -22.07,29.01 -14.11,14.1 -30.26,23.65 -30.94,24.05 l -4.17,-7.1 c 0.16,-0.09 15.92,-9.41 29.29,-22.78 9.69,-9.69 16.41,-20.01 19.2,-24.62 -3.69,-4.19 -11.44,-13.28 -14.99,-19.59 -4.39,-7.81 -6.54,-15.63 -7.59,-20.77 -12.19,7.89 -23.24,13.46 -25.9,14.77 l -3.18,1.56 -2.02,-2.91 c -0.72,-1.04 -17.68,-25.83 -17.68,-57.03 0,-31.2 16.95,-56.23 17.67,-57.28 l 2.02,-2.93 3.19,1.57 c 2.66,1.31 13.71,6.87 25.9,14.77 1.05,-5.14 3.2,-12.97 7.59,-20.77 3.55,-6.31 11.3,-15.4 14.99,-19.59 -2.79,-4.61 -9.51,-14.93 -19.2,-24.63 -13.35,-13.34 -29.13,-22.68 -29.29,-22.78 l 4.17,-7.1 c 0.68,0.4 16.83,9.95 30.94,24.06 13.81,13.81 21.74,28.4 22.07,29.01 l 1.38,2.57 -1.97,2.15 c -0.11,0.13 -11.72,12.89 -15.92,20.35 m -40.97,11.03 c -1.62,2.78 -4.08,7.34 -6.5,13.16 l 24.61,8.96 -2.81,7.74 -24.68,-8.99 c -2.39,7.17 -4.36,15.51 -4.84,24.45 h 27.76 v 8.23 h -27.77 c 0.46,8.97 2.41,17.31 4.8,24.48 l 24.73,-9.01 2.81,7.74 -24.66,8.98 c 2.44,5.82 4.91,10.37 6.54,13.14 18.36,-9.53 56.31,-32.7 56.31,-49.44 0,-16.75 -37.93,-39.9 -56.3,-49.44"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path108"
          />
          <path
            d="m 1342.29,1445.27 h -5.14 v -65.75 h 5.14 v 65.75"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path110"
          />
          <path
            d="m 1337.15,1146.64 h 5.14 v 65.75 h -5.14 v -65.75"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path112"
          />
          <path
            d="m 1313.69,1325.78 h 52.06 l -26.03,45.08 z m 9.27,5.35 16.76,29.03 16.76,-29.03 h -33.52"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path114"
          />
          <path
            d="m 1339.72,1221.04 26.03,45.09 h -52.06 z m 0,10.71 -16.76,29.03 h 33.52 l -16.76,-29.03"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path116"
          />
          <path
            d="m 1362.85,1295.95 c 0,12.54 -10.2,22.75 -22.74,22.75 -12.54,0 -22.75,-10.21 -22.75,-22.75 0,-12.54 10.21,-22.75 22.75,-22.75 12.54,0 22.74,10.21 22.74,22.75 m -40.14,0 c 0,9.6 7.81,17.4 17.4,17.4 9.59,0 17.39,-7.8 17.39,-17.4 0,-9.59 -7.8,-17.39 -17.39,-17.39 -9.59,0 -17.4,7.8 -17.4,17.39"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path118"
          />
          <path
            d="m 733.652,1379.52 h 0.043 v 53.4 h -0.043 v 12.35 h -5.148 v -65.75 h 0.043 5.105"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path120"
          />
          <path
            d="m 728.547,1212.39 h -0.043 v -65.75 h 5.148 v 12.35 h 0.043 v 53.4 h -0.043 -5.105"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path122"
          />
          <path
            d="m 705.09,1266.13 h -0.043 l 26.031,-45.08 0.02,0.03 0.019,-0.03 26.035,45.08 h -0.043 z m 26.008,-34.34 -16.735,28.99 h 33.473 z"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path124"
          />
          <path
            d="m 1267.11,877.711 c -7.07,1.301 -14.32,1.598 -20.06,2.969 -5.82,1.398 -9.6,3.461 -11.47,8 -0.51,1.281 -0.75,2.539 -0.75,3.769 0.01,4.18 2.8,8.571 10,11.551 3.19,1.301 5.87,1.789 8.15,1.789 7.55,0.02 11.71,-5.578 14.71,-9.789 l 1.33,-1.879 8.23,3.367 -10.61,23.742 -2.1,-0.281 c -4.4,-0.539 -13.17,-1.558 -22.83,-5.469 -7.29,-2.949 -13.5,-6.57 -18.02,-11.179 -4.52,-4.563 -7.31,-10.301 -7.28,-16.781 0,-3.442 0.74,-7.02 2.25,-10.77 3.58,-8.969 10.95,-13.109 18.82,-15.301 6.38,-1.758 14.78,-1.859 22.08,-3.019 3.62,-0.551 6.95,-1.371 9.41,-2.578 2.51,-1.231 4.07,-2.692 4.91,-4.743 0.39,-0.949 0.56,-1.91 0.56,-2.859 0.01,-3.422 -2.52,-7.48 -9.33,-10.301 -2.67,-1.07 -4.93,-1.48 -6.82,-1.48 -5.9,0 -9.41,4.043 -11.94,8.293 l -1.25,2.16 -8.49,-3.442 1.23,-2.71 9,-19.981 2.27,0.473 c 3.73,0.789 12.24,2.418 20.44,5.738 13.86,5.559 22.23,14.441 22.24,25.391 0,3 -0.64,6.07 -1.87,9.109 -4.28,10.648 -13.67,14.461 -22.81,16.211"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path126"
          />
          <path
            d="m 1409.07,1843.67 1.2,1.94 -6.29,6.33 -17.71,-19 1.07,-1.85 c 2.24,-3.85 6.57,-11.57 13.93,-18.94 7.84,-7.84 16.13,-13.26 24.86,-14.08 l 0.1,-0.01 c 6.85,-0.6 13.72,1.99 19.66,7.97 4.5,4.46 6.55,9.72 6.99,15.03 0.25,2.75 0.1,5.51 -0.26,8.28 -0.64,5.06 -2.68,10.76 -4.37,16.43 -1.72,5.64 -3.07,11.23 -2.67,15.32 0.23,2.51 0.96,4.34 2.43,5.81 1.69,1.66 3.69,2.39 6.15,2.2 2.66,-0.22 5.96,-1.72 9.37,-5.15 4.28,-4.35 5.16,-7.88 4.91,-11.1 -0.27,-3.19 -1.96,-6.29 -3.87,-8.85 l -1.48,-1.99 6.43,-6.46 2.04,2.2 14.94,16.11 -1.36,1.91 c -2.2,3.07 -7.04,10.28 -13.22,16.55 -7.25,7.23 -14.7,11.46 -22.06,12.12 -6.49,0.61 -12.72,-1.82 -17.71,-6.84 -4.5,-4.47 -6.56,-9.78 -7,-15.05 -0.36,-4.1 0.17,-8.21 1.02,-12.25 2.22,-9.79 6.17,-19.29 5.48,-25.99 -0.27,-2.88 -1.18,-5.15 -3.29,-7.3 -2.21,-2.16 -4.79,-3.13 -7.77,-2.87 -2.97,0.25 -6.45,1.84 -9.98,5.37 -5.18,5.26 -6.17,9.57 -5.88,13.42 0.35,4.12 2.55,7.89 4.34,10.74"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path128"
          />
          <path
            d="m 465.469,1166.68 c 0.058,1 0.14,1.2 1.027,2.06 0.91,0.84 2.844,1.86 5.793,3.05 l 50.395,20.32 c 3.207,1.32 5.418,1.9 6.578,1.88 1.047,-0.05 1.242,-0.14 1.988,-0.88 0.711,-0.75 1.629,-2.4 2.641,-4.93 l 1.066,-2.65 8.277,3.28 -1.093,2.67 -14.34,35.55 -8.231,-3.4 1.067,-2.65 c 1.07,-2.61 1.535,-4.44 1.511,-5.46 -0.07,-1 -0.14,-1.23 -1.035,-2.12 -0.918,-0.81 -2.824,-1.86 -5.777,-3.05 l -50.402,-20.33 c -3.137,-1.29 -5.336,-1.84 -6.52,-1.84 -1.066,0.07 -1.305,0.18 -2.047,0.88 -0.711,0.77 -1.613,2.37 -2.64,4.88 l -1.067,2.65 -8.254,-3.27 15.426,-38.25 8.231,3.47 -1.059,2.62 c -1.094,2.65 -1.559,4.51 -1.535,5.52"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path130"
          />
          <path
            d="m 575.961,1132.23 -1.043,1.72 -6.719,11.11 -76.117,-14.14 c -2.266,-0.44 -4.023,-0.65 -5.367,-0.65 -1.863,0.03 -2.781,0.33 -3.863,1.1 -1.067,0.78 -2.348,2.32 -3.907,4.9 l -1.484,2.46 -7.625,-4.57 19.18,-31.92 7.613,4.67 -1.481,2.44 c -2.136,3.46 -2.882,5.81 -2.812,6.55 0.094,0.56 -0.137,0.23 0.492,0.73 0.524,0.39 1.961,0.84 5.238,1.44 l 49.672,9.37 -31.945,-38.53 c -2.207,-2.65 -3.172,-3.46 -3.938,-3.95 -0.449,-0.26 -0.66,-0.28 -0.738,-0.28 -0.078,0 -0.355,0 -1.121,0.72 -0.73,0.7 -1.711,2.02 -2.812,3.86 l -1.493,2.47 -7.636,-4.6 21.461,-35.69 7.625,4.65 -1.473,2.46 c -1.988,3.26 -2.691,5.21 -2.652,6.51 -0.094,1.7 1.289,4.12 5.379,8.97 l 47.566,58.2"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path132"
          />
          <path
            d="m 440.176,1232.93 c 0.082,1.58 0.219,1.79 1.058,2.53 0.907,0.73 3.032,1.59 6.461,2.4 l 52.746,13.16 c 2.582,0.65 4.528,0.98 5.801,0.96 1.692,-0.06 1.957,-0.27 2.598,-0.94 0.625,-0.74 1.418,-2.53 2.133,-5.49 l 0.687,-2.76 8.66,2.09 -0.695,2.81 -15.551,62.4 -23.621,-4.86 2.277,-9.14 2.696,0.54 c 1.281,0.26 2.457,0.39 3.465,0.39 2.304,-0.02 3.765,-0.55 5.164,-1.83 1.383,-1.33 2.726,-3.72 3.715,-7.74 l 2.835,-11.27 c 0.442,-1.73 0.653,-2.98 0.653,-3.59 -0.137,-0.79 0.14,-0.26 -0.371,-0.74 -0.578,-0.42 -2.348,-1.07 -5.207,-1.79 l -22.598,-5.58 -3.301,13.25 c -0.418,1.7 -0.605,2.97 -0.605,3.88 0.082,1.59 0.258,1.75 0.922,2.35 0.73,0.61 2.496,1.3 5.23,1.93 l 2.824,0.67 -2.23,8.93 -30.973,-7.69 2.156,-8.91 2.797,0.7 c 2.278,0.56 3.981,0.86 5.012,0.84 1.316,-0.07 1.316,-0.14 1.801,-0.66 0.488,-0.55 1.183,-2.13 1.828,-4.8 l 3.301,-13.28 -18.914,-4.74 c -1.864,-0.47 -3.289,-0.68 -4.207,-0.68 -1.164,0.05 -1.289,0.19 -1.614,0.47 -0.339,0.32 -0.898,1.34 -1.363,3.28 l -1.941,7.83 c -0.711,2.86 -1.012,5.16 -1.012,6.93 0.051,3.16 0.805,4.58 1.895,5.69 1.117,1.14 3,2 5.429,2.79 l 2.543,0.82 -2.265,9.07 -23.133,-6.79 15.742,-63.22 8.668,2.19 -0.695,2.79 c -0.536,2.12 -0.813,3.74 -0.801,4.81"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path134"
          />
          <path
            d="m 597.34,1858.42 c 3,2.74 4.812,3.58 5.566,3.5 0.481,0 1.059,-0.14 2.117,-0.9 1.047,-0.73 2.426,-2.06 4.125,-3.93 l 36.372,-40.41 c 3.234,-3.52 4.265,-5.68 4.175,-6.5 0.09,-0.76 -0.765,-2.43 -4.09,-5.36 l -2.164,-1.94 6.024,-6.58 2.113,1.91 28.41,25.56 -5.953,6.66 -2.137,-1.94 c -2.968,-2.72 -4.781,-3.56 -5.546,-3.48 -0.477,0 -1.059,0.15 -2.125,0.9 -1.047,0.73 -2.418,2.04 -4.094,3.93 l -36.379,40.38 c -3.234,3.51 -4.262,5.67 -4.152,6.51 -0.11,0.78 0.781,2.45 4.054,5.36 l 2.125,1.92 -5.957,6.65 -30.551,-27.51 5.907,-6.67 2.16,1.94"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path136"
          />
          <path
            d="m 417.801,1330.59 c -0.067,0.76 -0.11,1.48 -0.121,2.11 -0.059,3.28 0.429,4.22 1.043,4.72 0.66,0.65 2.968,1.38 7.285,1.65 l 54.23,4.26 c 0.918,0.06 1.754,0.11 2.52,0.13 3.578,0.08 4.894,-0.49 5.375,-1.06 0.594,-0.52 1.297,-2.43 1.562,-6.28 l 0.227,-2.91 8.887,0.76 -0.223,2.85 -2.488,32.22 -8.91,-0.7 0.234,-2.88 c 0.066,-0.82 0.109,-1.54 0.125,-2.21 0.058,-3.25 -0.434,-4.15 -1.047,-4.63 -0.656,-0.65 -2.992,-1.35 -7.309,-1.65 l -46.144,-3.56 61,42.11 -1.258,16.48 -71.941,-5.54 c -0.996,-0.08 -1.903,-0.15 -2.719,-0.17 -3.531,-0.09 -4.801,0.49 -5.231,0.99 -0.57,0.49 -1.269,2.41 -1.527,6.33 l -0.234,2.89 -8.871,-0.76 2.711,-34.98 8.882,0.57 -0.226,2.9 c -0.07,0.79 -0.11,1.48 -0.121,2.11 -0.059,3.28 0.453,4.24 1.066,4.75 0.66,0.64 2.969,1.37 7.309,1.67 l 42.613,3.33 -57.637,-39.84 2.246,-29.16 8.918,0.6 -0.226,2.9"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path138"
          />
          <path
            d="m 685.809,1886.05 c 0.816,0 1.609,0.02 2.398,0.05 7.16,0.3 14.262,1.63 20.152,1.6 6.012,-0.04 10.153,-1.18 12.989,-5.19 1.242,-1.79 1.824,-3.67 1.836,-5.62 0,-3.55 -2.059,-7.68 -7.371,-11.41 -4.29,-3 -7.778,-3.95 -10.754,-3.95 -5.614,-0.04 -10.075,3.69 -13.293,6.58 l -1.703,1.51 -7.321,-5.11 15.668,-20.72 2,0.73 c 4.188,1.55 12.508,4.5 21.039,10.46 11.078,7.78 18.871,16.98 18.938,27.89 0.011,4.95 -1.711,10.03 -5.199,14.98 -5.52,7.99 -13.622,10.38 -21.805,10.7 -0.477,0.03 -0.949,0.03 -1.453,0.03 -7.532,-0.03 -16.957,-2.25 -24.61,-2.21 -5.683,0 -9.715,1.19 -11.718,4.11 -0.934,1.37 -1.395,2.78 -1.395,4.31 -0.008,3.02 1.898,6.88 7,10.44 3.57,2.5 6.484,3.31 8.949,3.32 4.352,0.02 8.024,-2.72 10.86,-5.72 l 1.695,-1.81 7.512,5.26 -1.817,2.39 -13.273,17.43 -2.113,-0.97 c -3.43,-1.63 -11.383,-5.14 -18.602,-10.18 -10.484,-7.34 -16.457,-15.94 -16.508,-25.12 0,-4.53 1.539,-9.01 4.434,-13.12 5.937,-8.58 14.937,-10.72 23.465,-10.66"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path140"
          />
          <path
            d="m 541.141,1771.27 c 4.757,-3.89 10.058,-5.43 15.195,-5.4 4.316,0 8.519,1 12.59,2.32 9.625,3.25 18.808,8.26 25.57,8.15 2.77,-0.02 5.035,-0.67 7.305,-2.49 2.437,-2.01 3.644,-4.52 3.668,-7.57 0,-2.94 -1.231,-6.51 -4.309,-10.32 -4.801,-5.83 -9.055,-7.22 -13.012,-7.27 -4.015,-0.01 -7.878,1.73 -10.832,3.18 l -2.046,1.01 -5.633,-6.92 20.75,-15.63 1.718,1.26 c 3.598,2.61 10.829,7.74 17.368,15.82 6.855,8.51 11.332,17.17 11.367,25.8 0.047,7.06 -3.254,13.81 -10.008,19.23 -4.742,3.88 -10.012,5.41 -15.172,5.38 -2.906,0 -5.816,-0.45 -8.703,-1.12 -5.012,-1.19 -10.512,-3.86 -16.035,-6.16 -5.477,-2.33 -10.926,-4.24 -15.039,-4.2 -2.395,0.01 -4.207,0.54 -5.778,1.8 -1.875,1.55 -2.824,3.49 -2.847,6.05 0,2.63 1.164,6.02 4.137,9.68 3.964,4.81 7.441,6.02 10.742,6.07 3.125,0.01 6.312,-1.34 8.972,-2.92 l 2.141,-1.27 5.766,7.07 -2.407,1.8 -17.578,13.14 -1.754,-1.54 c -2.836,-2.49 -9.496,-8.07 -15.062,-14.91 -6.324,-7.81 -9.742,-15.52 -9.754,-22.8 -0.035,-6.66 3.047,-12.75 8.68,-17.24"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path142"
          />
          <path
            d="m 413.152,1454.61 c 0.446,3.35 1.129,5.25 1.711,5.91 0.535,0.6 1.098,0.99 3.52,1.04 1.199,0 2.758,-0.14 4.672,-0.42 l 53.859,-7.58 c 3.836,-0.5 6.09,-1.24 6.918,-1.91 0.727,-0.61 1.031,-1 1.098,-3.3 0,-0.97 -0.102,-2.24 -0.321,-3.78 l -0.394,-2.8 8.808,-1.38 0.422,2.9 4.481,31.96 -8.821,1.37 -0.406,-2.88 c -0.457,-3.41 -1.14,-5.34 -1.719,-5.99 -0.515,-0.59 -1.011,-0.95 -3.398,-1.01 -1.211,0 -2.801,0.15 -4.762,0.43 l -45.871,6.43 68.688,28.01 2.289,16.35 -71.442,10.06 c -3.882,0.5 -6.16,1.21 -6.972,1.85 -0.711,0.6 -1,0.91 -1.074,3.26 0,1.02 0.121,2.33 0.339,3.95 l 0.407,2.85 -8.832,1.21 -4.926,-34.84 8.832,-1.21 0.406,2.84 c 0.441,3.35 1.129,5.25 1.723,5.89 0.523,0.59 1.078,0.99 3.543,1.03 1.195,0 2.73,-0.14 4.617,-0.4 l 42.367,-5.95 -64.887,-26.48 -4.066,-29.04 8.785,-1.21 0.406,2.84"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path144"
          />
          <path
            d="m 433.613,1576.1 c 0.86,2.74 1.707,4.45 2.383,5.2 0.695,0.71 0.918,0.85 2.238,0.92 1.262,0.01 3.352,-0.43 6.254,-1.39 l 51.7,-16.79 c 3.167,-1.01 5.195,-1.97 6.109,-2.75 0.875,-0.81 0.965,-0.99 1.047,-2.25 0.015,-1.06 -0.36,-2.81 -1.141,-5.21 l -0.883,-2.69 8.477,-2.88 0.894,2.78 19.887,61.14 -22.609,8.44 -2.938,-8.98 2.594,-0.97 c 2.473,-0.93 4.195,-2.02 5.203,-3.23 1.024,-1.22 1.567,-2.58 1.594,-4.84 0,-1.63 -0.348,-3.72 -1.176,-6.27 l -3.59,-11.03 c -0.625,-2 -1.183,-3.26 -1.488,-3.63 -0.348,-0.3 0.094,-0.13 -0.617,-0.23 -0.754,-0.02 -2.567,0.38 -5.289,1.27 l -22.129,7.23 4.203,12.98 c 0.769,2.41 1.586,3.82 2.168,4.43 0.605,0.56 0.824,0.66 1.859,0.72 1.024,0 2.715,-0.36 5.008,-1.13 l 2.723,-0.89 2.894,8.69 -30.414,9.92 -2.785,-8.73 2.719,-0.9 c 2.672,-0.86 4.406,-1.65 5.117,-2.24 0.676,-0.63 0.676,-0.58 0.742,-1.62 0.024,-0.87 -0.304,-2.45 -1.035,-4.66 l -4.223,-12.98 -18.527,6 c -2.367,0.75 -3.867,1.48 -4.484,2.02 -0.571,0.57 -0.559,0.53 -0.629,1.38 -0.008,0.61 0.164,1.61 0.617,3 l 2.519,7.68 c 1.512,4.69 3.165,7.35 4.629,8.71 1.461,1.32 2.649,1.66 4.418,1.7 1.266,0.01 2.789,-0.27 4.485,-0.68 l 2.605,-0.65 2.824,8.91 -23.168,6.5 -20.175,-61.97 8.496,-2.77 0.894,2.74"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path146"
          />
          <path
            d="m 469.172,1675.63 c 1.191,2.18 2.23,3.64 3.008,4.37 0.824,0.72 1.129,0.81 1.871,0.84 1.051,0.05 3.301,-0.7 6.699,-2.63 l 47.563,-26.33 c 2.554,-1.42 4.277,-2.6 5.136,-3.51 0.887,-0.95 0.981,-1.32 1.012,-2.04 0.039,-0.91 -0.594,-2.83 -2.184,-5.68 l -1.382,-2.51 7.789,-4.32 1.394,2.52 15.645,28.26 -7.762,4.35 -1.41,-2.5 c -1.219,-2.22 -2.258,-3.69 -3.035,-4.42 -0.825,-0.72 -1.118,-0.8 -1.836,-0.84 -1.02,-0.05 -3.289,0.72 -6.719,2.66 l -40.449,22.44 74.09,1.54 8.046,14.49 -63.136,34.97 c -2.567,1.42 -4.309,2.59 -5.203,3.5 -0.899,0.94 -0.965,1.26 -1,1.93 -0.039,0.87 0.593,2.81 2.254,5.72 l 1.406,2.51 -7.785,4.32 -17.114,-30.76 7.801,-4.26 1.383,2.48 c 1.219,2.17 2.258,3.63 3.047,4.34 0.816,0.73 1.137,0.82 1.883,0.87 1.043,0.04 3.289,-0.71 6.671,-2.63 l 37.45,-20.77 -70.114,-1.49 -14.23,-25.6 7.805,-4.34 1.406,2.52"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path148"
          />
          <path
            d="m 867.648,901.391 -2.75,-8.481 2.754,-0.89 c 2.703,-0.852 4.418,-1.668 5.176,-2.329 0.723,-0.711 0.856,-0.91 0.953,-2.191 0.039,-1.23 -0.39,-3.359 -1.347,-6.352 l -16.618,-51.75 c -0.972,-3.16 -1.91,-5.16 -2.679,-6.078 -0.805,-0.902 -1.016,-1 -2.231,-1.101 -1.054,-0.039 -2.843,0.32 -5.301,1.082 l -2.718,0.847 -2.727,-8.41 39.199,-12.578 2.676,8.481 -2.715,0.871 c -2.707,0.867 -4.429,1.687 -5.215,2.379 -0.722,0.679 -0.839,0.859 -0.925,2.089 -0.051,1.239 0.386,3.379 1.375,6.43 l 16.605,51.75 c 1.008,3.129 1.926,5.18 2.688,6.102 0.793,0.898 0.972,0.988 2.183,1.09 1.043,0.046 2.84,-0.313 5.348,-1.122 l 2.726,-0.871 2.715,8.481 -2.738,0.871 -36.434,11.68"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path150"
          />
          <path
            d="m 801.711,926.762 -3.602,-8.184 2.625,-1.16 c 2.418,-1.066 4,-1.996 4.746,-2.738 0.731,-0.77 0.825,-1 0.879,-1.961 0.028,-1.16 -0.593,-3.367 -2.043,-6.578 l -22.144,-49.68 c -1.242,-2.832 -2.328,-4.672 -3.176,-5.582 -0.879,-0.879 -1.16,-0.969 -2.066,-1.02 -0.977,-0.019 -2.86,0.493 -5.524,1.719 l -2.636,1.192 -3.625,-8.192 37.582,-16.738 3.609,8.191 -2.625,1.16 c -2.453,1.071 -4.047,2.02 -4.805,2.739 -0.726,0.769 -0.797,1 -0.867,1.91 -0.023,1.14 0.606,3.371 2.094,6.621 l 22.133,49.687 c 1.25,2.832 2.32,4.692 3.164,5.602 0.879,0.91 1.133,0.98 2.019,1.02 0.973,0.019 2.856,-0.489 5.578,-1.739 l 2.637,-1.191 3.637,8.191 -2.625,1.18 -34.965,15.551"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path152"
          />
          <path
            d="m 969.867,877.418 c -4.937,0.672 -9.656,1.07 -14.144,0.953 -8.903,-0.199 -17.086,-2.519 -23.332,-8.891 -6.262,-6.339 -10.34,-16.25 -12.317,-31.05 -0.625,-4.801 -0.886,-9.16 -0.789,-13.11 0.278,-12.808 4.547,-21.769 11.676,-27.468 7.105,-5.711 16.519,-8.153 27.043,-9.563 l 35.301,-4.668 1.187,8.77 -2.855,0.39 c -3.313,0.41 -5.25,1.059 -5.926,1.641 -0.633,0.527 -0.977,0.957 -1.082,3.207 -0.043,1.262 0.094,2.93 0.383,5.031 l 7.144,53.879 c 0.485,3.781 1.168,6.051 1.824,6.902 0.61,0.77 0.879,1.028 3.032,1.149 1.031,0.031 2.406,-0.078 4.108,-0.289 l 2.83,-0.391 1.26,8.84 -2.88,0.391 z m 2.828,-18.297 -7.183,-53.902 c -0.367,-2.957 -0.91,-4.668 -1.293,-5.149 -0.36,-0.371 -0.176,-0.441 -1.672,-0.582 -0.707,-0.008 -1.731,0.063 -3.016,0.231 -8.258,1.121 -13.109,3.422 -15.929,6.511 -2.825,3.098 -4.079,7.391 -4.247,13.5 -0.113,4.489 0.407,9.848 1.227,15.961 1.418,10.848 3.441,18.739 6.609,23.508 3.196,4.731 7.094,6.93 14.36,7.199 h 0.058 c 1.996,0.051 4.231,-0.078 6.727,-0.41 2.566,-0.328 3.828,-0.929 4.176,-1.238 0.281,-0.301 0.426,-0.441 0.504,-1.738 0.027,-0.903 -0.11,-2.231 -0.321,-3.891"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path154"
          />
          <path
            d="m 1196.39,830.379 0.14,-2.438 c 0.06,-0.91 0.1,-1.773 0.1,-2.582 -0.03,-3.507 -0.58,-5.558 -1.98,-7.121 -1.42,-1.597 -4.35,-3.179 -9.93,-4.34 l -1.99,-0.449 -12.59,59.262 c -0.52,2.398 -0.76,4.238 -0.76,5.488 0.07,1.91 0.32,2.262 0.97,2.86 0.7,0.632 2.56,1.371 5.63,1.972 l 2.81,0.61 -1.82,8.718 -2.82,-0.609 -37.43,-7.898 1.81,-8.793 2.83,0.601 c 1.96,0.43 3.49,0.629 4.57,0.629 1.79,-0.09 2.04,-0.277 2.73,-1.07 0.71,-0.879 1.54,-3.039 2.28,-6.551 l 12.58,-59.277 -1.88,-0.422 c -2.7,-0.559 -4.91,-0.809 -6.68,-0.809 -3.2,0.02 -4.81,0.719 -6.18,1.969 -1.38,1.281 -2.6,3.531 -3.77,6.832 l -0.83,2.379 -8.98,-1.86 6.08,-24.671 68.34,14.531 -4.3,25.058 -8.93,-2.019"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path156"
          />
          <path
            d="m 1113.09,796.328 c -0.54,-0.039 -1.07,-0.066 -1.56,-0.078 -3.57,-0.07 -4.75,0.461 -5.23,1.102 -0.66,0.609 -1.39,2.918 -1.6,7.398 l -2.51,42.172 c -0.55,9.219 -3.03,16.828 -8.52,22.019 -5.5,5.188 -13.54,7.5 -24.09,7.25 -0.77,-0.05 -1.58,-0.07 -2.39,-0.113 -12.77,-0.758 -21.03,-4.59 -25.84,-10.519 -4.8,-5.938 -5.85,-13.309 -5.68,-20.379 0.02,-0.739 0.05,-1.512 0.11,-2.27 l 2.5,-42.129 c 0.05,-0.672 0.08,-1.32 0.1,-1.902 0.12,-3.899 -0.5,-5.457 -1.06,-5.93 -0.51,-0.597 -2.39,-1.301 -6.36,-1.48 l -2.83,-0.188 0.47,-8.941 36.46,2.23 -0.6,8.86 -2.85,-0.16 c -0.56,-0.04 -1.09,-0.079 -1.57,-0.09 -3.56,-0.071 -4.73,0.488 -5.22,1.101 -0.65,0.617 -1.39,2.918 -1.6,7.379 l -2.49,42.129 c -0.04,0.859 -0.09,1.691 -0.11,2.461 -0.16,6.738 0.89,11.051 3.05,13.578 2.11,2.543 5.82,4.172 12.56,4.57 0.42,0.012 0.8,0.051 1.18,0.051 6.76,0.082 9.75,-1.75 11.83,-4.699 2.08,-3.039 3.02,-8.039 3.34,-14.012 l 2.52,-42.136 c 0.03,-0.641 0.05,-1.243 0.07,-1.821 0.12,-3.972 -0.5,-5.57 -1.07,-6.051 -0.49,-0.621 -2.35,-1.308 -6.33,-1.5 l -2.86,-0.171 0.48,-8.899 41.08,2.442 -0.5,8.898 -2.88,-0.172"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path158"
          />
          <path
            d="m 1232.58,1918.8 c 6.26,-2.52 12.28,-4.13 17.95,-4.43 0.16,-0.01 0.31,-0.03 0.47,-0.04 10.79,-0.57 20.45,4.55 25.04,16.3 1.07,2.67 1.66,5.28 1.78,7.81 0.31,5.98 -1.78,11.33 -4.66,16.29 -3.04,5.17 -8.2,10.46 -12.46,15.8 -4.3,5.32 -7.35,10.62 -7.05,14.5 0.04,0.84 0.22,1.65 0.55,2.45 1.37,3.2 4.11,5.07 8.96,4.9 1.9,-0.1 4.07,-0.58 6.5,-1.56 4.29,-1.76 6.58,-3.92 7.88,-6.15 1.3,-2.23 1.68,-4.71 1.55,-7.26 -0.08,-1.53 -0.35,-3.08 -0.71,-4.52 l -0.58,-2.4 8.49,-3.44 1.01,2.81 7.43,20.63 -1.99,1.22 c -3.23,2 -10.51,6.77 -18.68,10.07 -5.44,2.21 -10.54,3.45 -15.25,3.7 -10.7,0.71 -19.54,-4.5 -23.38,-14.36 -1.08,-2.65 -1.67,-5.28 -1.79,-7.8 -0.39,-7.5 2.95,-13.93 6.94,-19.65 3.63,-5.09 7.85,-9.72 10.98,-14.11 3.18,-4.4 5.08,-8.42 4.85,-12.12 -0.05,-1.16 -0.3,-2.33 -0.8,-3.58 -1.75,-4.11 -5.15,-6.41 -10.63,-6.21 -1.98,0.11 -4.23,0.6 -6.68,1.58 -5.46,2.25 -8.19,5.04 -9.73,7.9 -1.52,2.87 -1.84,6 -1.68,8.98 0.09,1.71 0.34,3.33 0.57,4.77 l 0.35,2.25 -8.27,3.35 -8.88,-24.39 1.68,-1.29 c 3.57,-2.69 10.6,-8.09 20.24,-12"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path160"
          />
          <path
            d="m 1610.89,1647.72 c -0.93,-0.79 -2.88,-1.78 -5.86,-2.9 l -50.87,-19.17 c -3.2,-1.23 -5.41,-1.75 -6.58,-1.7 -1.04,0.08 -1.24,0.18 -1.97,0.92 -0.69,0.77 -1.57,2.43 -2.51,5.01 l -1,2.69 -8.38,-3.11 1.01,-2.71 13.5,-35.81 8.36,3.18 -1.01,2.69 c -1.01,2.62 -1.46,4.47 -1.41,5.47 0.09,1 0.17,1.23 1.08,2.07 0.93,0.8 2.87,1.79 5.83,2.9 l 50.89,19.17 c 3.18,1.21 5.39,1.72 6.56,1.67 1.06,-0.07 1.29,-0.2 2.01,-0.93 0.68,-0.77 1.58,-2.41 2.52,-4.96 l 1.02,-2.69 8.31,3.13 -14.48,38.55 -8.34,-3.24 1,-2.65 c 1.02,-2.67 1.44,-4.54 1.4,-5.55 -0.08,-0.98 -0.15,-1.19 -1.08,-2.03"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path162"
          />
          <path
            d="m 1634.08,1584.92 c -0.11,-1.57 -0.25,-1.77 -1.08,-2.5 -0.9,-0.7 -3.02,-1.55 -6.45,-2.34 l -52.87,-12.77 c -2.59,-0.63 -4.54,-0.93 -5.82,-0.92 -1.68,0.08 -1.95,0.29 -2.58,0.97 -0.63,0.74 -1.39,2.54 -2.08,5.5 l -0.7,2.85 -8.62,-2.22 0.67,-2.75 15.09,-62.45 23.63,4.68 -2.21,9.12 -2.7,-0.52 c -1.28,-0.24 -2.44,-0.36 -3.47,-0.36 -2.3,0.05 -3.76,0.58 -5.14,1.88 -1.38,1.33 -2.72,3.73 -3.69,7.74 l -2.7,11.32 c -0.44,1.77 -0.67,3.03 -0.65,3.63 0.14,0.76 -0.16,0.21 0.35,0.69 0.6,0.41 2.36,1.03 5.22,1.7 l 22.65,5.46 3.19,-13.27 c 0.43,-1.7 0.61,-3.02 0.59,-3.91 -0.09,-1.56 -0.26,-1.72 -0.94,-2.32 -0.72,-0.6 -2.5,-1.3 -5.24,-1.93 l -2.75,-0.68 2.06,-8.93 31.11,7.49 -2.17,8.93 -2.8,-0.67 c -2.28,-0.55 -3.96,-0.83 -5,-0.82 -1.29,0.09 -1.28,0.15 -1.78,0.68 -0.48,0.57 -1.17,2.18 -1.8,4.88 l -3.21,13.27 18.96,4.57 c 1.9,0.47 3.33,0.69 4.24,0.67 1.14,-0.05 1.24,-0.18 1.58,-0.49 0.32,-0.32 0.88,-1.35 1.34,-3.31 l 1.88,-7.84 c 0.7,-2.87 0.97,-5.16 0.96,-6.94 -0.07,-3.15 -0.84,-4.55 -1.94,-5.67 -1.13,-1.12 -3,-1.97 -5.42,-2.73 l -2.53,-0.8 2.11,-9.08 23.23,6.62 -15.29,63.37 -8.67,-2.2 0.68,-2.76 c 0.52,-2.13 0.76,-3.76 0.76,-4.84"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path164"
          />
          <path
            d="m 1639.94,1381.91 2.39,-0.59 c 3.91,-0.93 6.46,-2.02 7.86,-3.48 1.39,-1.45 2.33,-3.63 2.35,-8.23 0,-1.09 -0.06,-2.33 -0.18,-3.68 l -0.18,-2.07 -60.39,5.3 c -4.11,0.31 -6.41,1 -7.15,1.66 -0.66,0.53 -1.1,1.18 -1.15,4.04 0,0.84 0.05,1.81 0.15,2.93 l 0.26,2.88 -8.87,0.7 -0.26,-2.83 -3.36,-38.13 8.92,-0.7 0.25,2.84 c 0.28,3.6 0.93,5.53 1.51,6.14 0.47,0.55 1.38,1.07 4.4,1.09 1.01,0 2.21,-0.07 3.6,-0.19 l 60.38,-5.3 -0.17,-1.9 c -0.55,-6.35 -1.96,-9.52 -3.64,-11.05 -1.64,-1.58 -4.35,-2.32 -8.87,-2.51 l -2.5,-0.11 -0.87,-9.1 25.37,-1.44 6.11,69.66 -25.17,3.13 -0.79,-9.06"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path166"
          />
          <path
            d="m 1448.39,1786.3 c -3.06,0.17 -4.78,1.21 -7.94,5.08 l -1.76,2.26 -7.04,-5.51 1.79,-2.27 20.87,-26.46 7.01,5.49 -1.79,2.26 c -2.47,3.04 -3.27,5.12 -3.15,5.53 0.06,0.24 -0.03,0.34 0.78,1.02 0.78,0.62 2.08,1.17 3.48,1.56 l 0.05,0.02 11.23,3.61 17.79,-22.56 -6.56,-10.7 c -0.72,-1.28 -1.59,-2.34 -2.4,-3 -0.31,-0.21 -0.33,-0.17 -0.43,-0.19 -0.11,-0.02 -0.81,0.2 -1.76,1.04 -0.92,0.79 -2.01,2.04 -3.11,3.43 l -1.78,2.23 -7.01,-5.48 25.84,-32.84 7.01,5.5 -1.77,2.26 c -2.76,3.52 -3.61,5.57 -3.54,7.57 0.03,1.87 1.02,4.44 3.41,8.38 l 39.66,64.9 -8.9,11.27 -70.85,-22.56 c -4.11,-1.33 -7.06,-1.92 -9.13,-1.84 m 62.89,5.09 -15.12,-24.55 -12.45,15.82 27.57,8.73"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path168"
          />
          <path
            d="m 1565.68,1724.41 -47.54,-26.39 c -3.38,-1.88 -5.66,-2.64 -6.71,-2.59 -0.77,0.03 -1.07,0.12 -1.88,0.83 -0.79,0.72 -1.82,2.18 -3,4.34 l -1.38,2.5 -7.83,-4.26 1.41,-2.53 18.54,-33.47 7.81,4.31 -1.39,2.52 c -1.6,2.84 -2.26,4.77 -2.21,5.67 0.04,0.72 0.13,1.07 1,2.04 0.88,0.92 2.6,2.1 5.16,3.51 l 17.04,9.42 0.88,-1.58 c 2.95,-5.3 6.44,-11.25 10.99,-16.04 4.51,-4.75 10.33,-8.46 17.55,-8.46 4.15,0 8.62,1.23 13.37,3.86 9.17,4.98 13.38,12.69 13.29,20.81 -0.01,6.53 -2.4,13.2 -6.01,19.74 l -18.73,33.75 -7.83,-4.27 1.41,-2.53 c 1.62,-2.85 2.26,-4.76 2.21,-5.66 -0.03,-0.73 -0.12,-1.07 -1,-2.02 -0.88,-0.91 -2.59,-2.1 -5.15,-3.5 m 8.13,-14.7 1.39,-2.51 c 2.79,1.59 4.57,2.2 5.05,2.13 0.29,-0.04 0.24,0.05 0.71,-0.37 0.46,-0.39 1.17,-1.4 2.03,-2.97 2.21,-3.91 3.46,-7.24 3.44,-9.82 -0.05,-3.29 -1.65,-6.42 -8.72,-10.45 -3.93,-2.17 -6.95,-2.96 -9.25,-2.96 -2.93,0.03 -4.98,1.13 -7.09,3.25 -2.07,2.1 -3.95,5.21 -5.8,8.57 l -0.73,1.35 20.36,11.26 -1.39,2.52"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path170"
          />
          <path
            d="m 1645.44,1294.52 c -0.62,-3.11 -1.37,-4.97 -1.97,-5.67 -0.58,-0.63 -0.88,-0.86 -2.75,-0.93 -1.27,-0.03 -3.14,0.25 -5.57,0.76 l -53.2,11.3 c -3.55,0.75 -5.74,1.53 -6.62,2.23 -0.79,0.7 -0.97,0.89 -1.05,2.68 -0.01,1.09 0.21,2.65 0.63,4.62 l 0.6,2.84 -8.72,1.81 -0.6,-2.79 -7.96,-37.41 8.7,-1.83 0.61,2.79 c 0.63,3.09 1.37,4.93 2,5.63 0.59,0.64 0.93,0.91 2.86,0.97 1.28,0 3.09,-0.23 5.47,-0.74 l 53.2,-11.32 c 3.54,-0.73 5.7,-1.57 6.57,-2.26 0.81,-0.7 0.99,-0.95 1.09,-2.74 0,-1.07 -0.21,-2.61 -0.63,-4.58 l -0.59,-2.81 8.73,-1.82 8.54,40.2 -8.73,1.9 -0.61,-2.83"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path172"
          />
          <path
            d="m 1653.82,1492.83 c 0.05,-0.94 0.07,-1.79 0.05,-2.53 -0.07,-3.03 -0.54,-3.8 -1.21,-4.31 -0.71,-0.62 -3.03,-1.28 -7.27,-1.47 l -54.28,-3.08 c -1.18,-0.07 -2.22,-0.1 -3.14,-0.09 -3.28,0.06 -4.35,0.63 -4.81,1.2 -0.58,0.58 -1.2,2.51 -1.37,6.24 l -0.16,2.83 -8.88,-0.38 0.16,-2.91 1.83,-32.33 8.89,0.57 -0.17,2.86 c -0.06,0.98 -0.08,1.85 -0.07,2.61 0.07,3.05 0.56,3.78 1.21,4.27 0.7,0.61 3.03,1.25 7.27,1.44 l 46.21,2.6 -61.86,-40.82 0.93,-16.53 72.05,4.11 c 1.24,0.06 2.34,0.1 3.28,0.08 3.23,-0.05 4.25,-0.6 4.67,-1.14 0.55,-0.55 1.18,-2.52 1.37,-6.33 l 0.16,-2.87 8.88,0.49 -2,35.2 -8.88,-0.58 0.16,-2.85 c 0.06,-0.97 0.09,-1.83 0.09,-2.57 -0.09,-3.01 -0.57,-3.77 -1.23,-4.28 -0.73,-0.61 -3.06,-1.27 -7.27,-1.47 l -42.63,-2.41 58.4,38.59 -1.64,29.28 -8.9,-0.57 0.16,-2.85"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path174"
          />
          <path
            d="m 1562.48,1250.5 c -0.01,1.44 0.4,3.26 1.32,5.63 l 1.02,2.67 -8.3,3.28 -1.04,-2.72 -12.06,-31.43 8.31,-3.3 1.02,2.72 c 0.93,2.42 1.78,4.09 2.44,4.88 0.71,0.84 0.77,0.72 1.03,0.76 0.16,0 0.46,-0.04 0.93,-0.23 0.99,-0.37 2.05,-1.18 3.16,-2.2 l 8.87,-7.82 -10.31,-26.83 -12.6,0.17 h -0.06 c -0.13,-0.02 -0.25,-0.02 -0.39,-0.02 -1.18,0 -2.38,0.2 -3.32,0.53 -0.5,0.35 -0.3,-0.02 -0.46,1.12 -0.04,1.13 0.58,3.32 1.46,5.6 l 1.02,2.65 -8.3,3.27 -14.97,-39.03 8.31,-3.2 1.04,2.69 c 1.5,3.93 2.79,5.74 4.38,6.72 1.59,1.05 4.29,1.58 9.06,1.56 h 0.16 l 76.07,-0.84 5.11,13.39 -55.63,49.33 c -5.67,5.05 -7.28,7.7 -7.27,10.65 m 15.94,-35.96 21.62,-19.23 -28.83,0.4 7.21,18.83"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path176"
          />
          <path
            d="m 1580.45,1114.11 c -1.29,-2.07 -2.38,-3.47 -3.19,-4.15 -0.85,-0.7 -1.19,-0.79 -1.86,-0.83 -1.02,-0.02 -3.25,0.83 -6.68,2.99 l -46.06,28.9 c -2.41,1.51 -4.04,2.77 -4.88,3.7 -0.84,0.98 -0.93,1.39 -0.94,2.03 -0.03,0.89 0.68,2.81 2.5,5.65 l 1.52,2.44 -7.55,4.72 -1.52,-2.43 -34.15,-54.47 19.87,-13.63 4.97,7.95 -2.23,1.58 c -3.61,2.58 -4.97,4.65 -4.94,7.39 0.04,1.89 0.83,4.48 2.96,7.88 l 6.19,9.84 c 0.93,1.51 1.67,2.55 2.12,2.95 0.38,0.32 0.37,0.32 0.4,0.3 0.03,0 0.04,0 0.07,0.02 0.28,0.09 2.15,-0.6 5.21,-2.58 l 19.72,-12.35 -7.26,-11.63 c -1.13,-1.79 -2.1,-2.91 -2.8,-3.46 -0.73,-0.56 -1.02,-0.61 -1.56,-0.62 -0.84,-0.05 -2.69,0.68 -5.42,2.43 l -2.44,1.53 -4.84,-7.81 27.06,-16.92 4.86,7.79 -2.43,1.53 c -2.07,1.27 -3.47,2.32 -4.18,3.08 -0.68,0.78 -0.68,0.96 -0.7,1.41 -0.04,0.58 0.56,2.27 2.24,4.89 l 7.26,11.6 16.53,-10.33 c 1.81,-1.12 3.02,-2.07 3.62,-2.76 0.58,-0.71 0.58,-0.88 0.6,-1.25 0.02,-0.42 -0.33,-1.55 -1.43,-3.27 l -4.31,-6.88 c -4.44,-6.96 -7.36,-8.13 -9.67,-8.11 -1.6,0.02 -3.55,0.78 -5.82,1.99 l -2.35,1.23 -4.96,-7.88 20.96,-11.95 34.57,55.13 -7.51,4.82 -1.55,-2.46"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path178"
          />
          <path
            d="m 1386.88,1924.51 c 4.29,2.42 5.76,8.06 3.38,12.26 -2.45,4.29 -7.94,5.77 -12.25,3.37 -4.27,-2.45 -5.82,-7.96 -3.37,-12.23 2.39,-4.18 7.94,-5.82 12.24,-3.4"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path180"
          />
          <path
            d="m 1334.6,1867.38 c 2.39,-4.18 7.95,-5.83 12.25,-3.41 4.29,2.43 5.75,8.07 3.37,12.26 -2.44,4.29 -7.93,5.78 -12.24,3.38 -4.27,-2.46 -5.82,-7.96 -3.38,-12.23"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path182"
          />
          <path
            d="m 1387.62,1869.56 c 0.01,4.93 -3.98,9.02 -8.9,9.04 -4.81,0.02 -9.02,-3.97 -9.08,-8.9 -0.04,-4.93 4.11,-9.02 8.93,-9.05 4.94,-0.04 8.98,3.98 9.05,8.91"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path184"
          />
          <path
            d="m 1346.17,1925.58 c 4.93,-0.03 8.96,3.99 9.04,8.92 0.01,4.93 -3.98,9.02 -8.9,9.04 -4.81,0.01 -9.02,-3.97 -9.07,-8.91 -0.05,-4.92 4.1,-9.01 8.93,-9.05"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path186"
          />
          <path
            d="m 1321.69,1896.53 c 4.27,-2.47 9.81,-1.06 12.28,3.19 2.42,4.16 1.07,9.8 -3.17,12.32 -4.25,2.49 -9.86,0.94 -12.31,-3.22 -2.5,-4.25 -1.03,-9.75 3.2,-12.29"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path188"
          />
          <path
            d="m 1394.13,1892.13 c 4.27,-2.47 9.81,-1.06 12.28,3.19 2.42,4.16 1.08,9.79 -3.17,12.31 -4.25,2.5 -9.86,0.95 -12.31,-3.21 -2.49,-4.26 -1.03,-9.76 3.2,-12.29"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path190"
          />
          <path
            d="m 1342.69,1915.61 c -7.41,-10.81 -4.64,-25.64 6.18,-33.06 10.81,-7.41 25.64,-4.64 33.05,6.18 7.41,10.81 4.65,25.64 -6.17,33.05 -10.81,7.42 -25.64,4.65 -33.06,-6.17 m 30.03,1.76 c 8.39,-5.74 10.53,-17.24 4.79,-25.62 -5.75,-8.37 -17.24,-10.52 -25.62,-4.78 -8.38,5.75 -10.52,17.23 -4.78,25.61 5.75,8.38 17.23,10.53 25.61,4.79"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path192"
          />
          <path
            d="m 783.324,1976.35 c 4.809,-0.23 9.184,3.56 9.457,8.5 0.254,4.92 -3.711,9.18 -8.527,9.43 -4.934,0.25 -9.137,-3.58 -9.43,-8.51 -0.222,-4.93 3.586,-9.19 8.5,-9.42"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path194"
          />
          <path
            d="m 822.309,1918.55 c 0.257,4.92 -3.711,9.18 -8.528,9.43 -4.929,0.25 -9.133,-3.59 -9.429,-8.51 -0.223,-4.92 3.586,-9.18 8.5,-9.42 4.808,-0.23 9.179,3.57 9.457,8.5"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path196"
          />
          <path
            d="m 827.102,1953.28 c -2.602,-4.05 -1.504,-9.73 2.628,-12.44 4.133,-2.68 9.809,-1.38 12.438,2.68 2.68,4.14 1.461,9.7 -2.66,12.41 -4.153,2.66 -9.75,1.49 -12.406,-2.65"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path198"
          />
          <path
            d="m 757.551,1948.42 c 4.133,-2.68 9.808,-1.38 12.433,2.67 2.684,4.14 1.461,9.7 -2.656,12.42 -4.152,2.66 -9.746,1.49 -12.406,-2.65 -2.602,-4.05 -1.5,-9.73 2.629,-12.44"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path200"
          />
          <path
            d="m 769.242,1918.75 c 2.25,-4.4 7.676,-6.12 12.086,-3.92 4.375,2.27 6.168,7.7 3.91,12.08 -2.207,4.27 -7.675,6.16 -12.09,3.93 -4.386,-2.23 -6.101,-7.8 -3.906,-12.09"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path202"
          />
          <path
            d="m 823.977,1973.55 c 4.378,2.27 6.168,7.7 3.914,12.07 -2.207,4.28 -7.68,6.17 -12.09,3.94 -4.387,-2.24 -6.102,-7.8 -3.906,-12.09 2.246,-4.4 7.675,-6.12 12.082,-3.92"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path204"
          />
          <path
            d="m 807.719,1930.24 c 12.066,5.13 17.703,19.13 12.566,31.19 -5.137,12.07 -19.129,17.7 -31.191,12.56 -12.063,-5.13 -17.699,-19.13 -12.563,-31.19 5.133,-12.06 19.125,-17.69 31.188,-12.56 m -16.528,38.83 c 9.352,3.98 20.192,-0.39 24.168,-9.74 3.977,-9.35 -0.386,-20.19 -9.734,-24.17 -9.352,-3.98 -20.191,0.39 -24.168,9.74 -3.98,9.35 0.383,20.19 9.734,24.17"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path206"
          />
          <path
            d="m 1293.25,1956.55 c 0.76,-4.86 5.51,-8.23 10.27,-7.49 4.88,0.77 8.21,5.39 7.49,10.26 -0.79,4.87 -5.39,8.26 -10.25,7.48 -4.75,-0.76 -8.25,-5.37 -7.51,-10.25"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path208"
          />
          <path
            d="m 1295.66,1921.57 c 1.72,4.5 -0.52,9.84 -5.12,11.64 -4.59,1.78 -9.88,-0.66 -11.62,-5.16 -1.78,-4.6 0.56,-9.8 5.14,-11.61 4.61,-1.75 9.85,0.54 11.6,5.13"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path210"
          />
          <path
            d="m 1036.79,1993.67 c 4.88,0.76 8.21,5.38 7.49,10.26 -0.79,4.86 -5.39,8.26 -10.24,7.48 -4.76,-0.76 -8.26,-5.37 -7.52,-10.25 0.75,-4.87 5.51,-8.23 10.27,-7.49"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path212"
          />
          <path
            d="m 834.141,1717.34 c -5.586,-9.68 -7.078,-20.96 -4.184,-31.76 2.898,-10.8 9.824,-19.83 19.508,-25.42 10.484,-6.06 55.894,-18.55 93.875,-28.39 1.098,1.16 3.742,3.74 7.887,6.45 -42.043,10.81 -87.961,23.48 -97.645,29.08 -7.781,4.48 -13.348,11.74 -15.672,20.41 -2.32,8.67 -1.125,17.73 3.36,25.51 5.992,10.38 17.16,16.82 29.156,16.82 5.863,0 11.664,-1.56 16.777,-4.51 10.699,-6.17 51,-46.33 83.41,-79.66 3.063,0.55 6.328,0.91 9.871,0.91 0.239,0 0.485,-0.02 0.727,-0.03 -28.453,29.35 -76.883,78.4 -89.891,85.92 -6.363,3.67 -13.586,5.61 -20.894,5.61 -14.93,0 -28.828,-8.02 -36.285,-20.94"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path214"
          />
          <path
            d="m 993.273,1645.37 c 4.368,-0.97 8.267,-2.34 11.667,-3.9 -0.08,1.34 -0.09,2.71 -0.05,4.1 -34.808,33.56 -83.976,82.32 -90.867,94.26 -4.488,7.78 -5.683,16.84 -3.359,25.52 2.324,8.67 7.887,15.92 15.672,20.42 5.105,2.94 10.906,4.5 16.773,4.5 11.993,0 23.164,-6.44 29.153,-16.81 6.511,-11.28 22.629,-71.7 34.228,-117.91 0.12,0.4 0.2,0.81 0.33,1.21 1.28,3.85 3.06,7.58 5.05,11.04 -10.17,40 -25.546,97.77 -32.479,109.77 -7.453,12.92 -21.356,20.94 -36.282,20.94 -7.304,0 -14.531,-1.94 -20.894,-5.61 -9.684,-5.59 -16.61,-14.62 -19.508,-25.42 -2.894,-10.8 -1.402,-22.08 4.184,-31.76 7.554,-13.08 57.089,-61.96 86.382,-90.35"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path216"
          />
          <path
            d="m 1024.02,1684.43 c -11.2,40.42 -22.25,83.34 -22.25,94.07 0,18.54 15.09,33.63 33.63,33.63 18.54,0 33.62,-15.09 33.62,-33.63 0,-10.23 -10.02,-49.66 -20.65,-88.31 2.04,-0.88 4.66,-2.09 7.53,-3.59 10.21,37.05 21.36,80.17 21.36,91.9 0,23.08 -18.78,41.86 -41.86,41.86 -23.08,0 -41.865,-18.78 -41.865,-41.86 0,-12.8 13.275,-62.99 24.125,-101.88 2.34,3.16 4.58,5.82 6.36,7.81"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path218"
          />
          <path
            d="m 1069.91,1677.55 c 10.71,41.56 23.11,86.35 28.63,95.91 5.98,10.37 17.16,16.81 29.15,16.81 5.86,0 11.67,-1.56 16.77,-4.5 7.79,-4.5 13.34,-11.75 15.68,-20.42 2.32,-8.68 1.12,-17.74 -3.37,-25.52 -5.71,-9.89 -40.45,-45.06 -71.99,-75.93 h 2.66 c 4.65,4.23 10.19,7.32 16.42,9.03 0.78,0.21 1.57,0.37 2.36,0.56 25.53,25.34 52.3,52.89 57.69,62.23 5.58,9.68 7.07,20.96 4.18,31.76 -2.9,10.8 -9.82,19.83 -19.51,25.42 -6.36,3.67 -13.58,5.61 -20.89,5.61 -14.93,0 -28.83,-8.02 -36.29,-20.93 -6.11,-10.59 -18.78,-56.73 -28.66,-94.91 2.42,-1.54 4.86,-3.24 7.17,-5.12"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path220"
          />
          <path
            d="m 1117.5,1675.23 c 1.65,0.12 3.3,0.18 4.97,0.18 2.3,0 4.43,-0.14 6.48,-0.32 24.21,24.24 46.99,46.03 54.64,50.44 5.11,2.95 10.92,4.51 16.78,4.51 11.99,0 23.17,-6.44 29.15,-16.82 9.27,-16.05 3.75,-36.66 -12.3,-45.93 -7,-4.04 -32.93,-11.78 -62.64,-19.84 l -2.22,-2.46 c -1.71,-1.94 -4.29,-5.05 -6.96,-8.51 33.21,8.83 67.06,18.56 75.94,23.68 19.98,11.55 26.85,37.2 15.31,57.18 -7.45,12.92 -21.35,20.94 -36.28,20.94 -7.31,0 -14.53,-1.94 -20.89,-5.62 -9.3,-5.36 -36.71,-31.97 -61.98,-57.43"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path222"
          />
          <path
            d="m 1026.4,1436.78 c -2.44,4.3 -7.94,5.78 -12.25,3.38 -4.27,-2.46 -5.82,-7.97 -3.37,-12.23 2.39,-4.18 7.94,-5.83 12.25,-3.41 4.28,2.43 5.75,8.07 3.37,12.26"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path224"
          />
          <path
            d="m 1051.84,1339.86 c 4.29,2.43 5.76,8.07 3.38,12.26 -2.44,4.29 -7.94,5.78 -12.25,3.38 -4.27,-2.46 -5.82,-7.96 -3.37,-12.23 2.39,-4.18 7.94,-5.83 12.24,-3.41"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path226"
          />
          <path
            d="m 1034.86,1325.45 c 4.29,2.43 5.75,8.07 3.37,12.26 -2.44,4.29 -7.93,5.78 -12.24,3.38 -4.27,-2.46 -5.82,-7.96 -3.38,-12.23 2.39,-4.18 7.95,-5.83 12.25,-3.41"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path228"
          />
          <path
            d="m 1071.4,1350.15 c 4.29,2.43 5.75,8.07 3.37,12.26 -2.44,4.3 -7.93,5.78 -12.24,3.38 -4.27,-2.46 -5.82,-7.96 -3.38,-12.23 2.39,-4.17 7.95,-5.82 12.25,-3.41"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path230"
          />
          <path
            d="m 1084.37,1388.81 c 2.4,-4.17 7.94,-5.82 12.25,-3.4 4.29,2.43 5.75,8.06 3.37,12.26 -2.44,4.29 -7.93,5.77 -12.24,3.37 -4.28,-2.45 -5.82,-7.96 -3.38,-12.23"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path232"
          />
          <path
            d="m 1038.81,1401.04 c -4.27,-2.45 -5.82,-7.96 -3.37,-12.22 2.39,-4.18 7.94,-5.83 12.25,-3.41 4.28,2.43 5.75,8.06 3.37,12.26 -2.44,4.29 -7.93,5.77 -12.25,3.37"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path234"
          />
          <path
            d="m 1100.22,1406.51 c 4.29,2.43 5.75,8.06 3.38,12.26 -2.45,4.29 -7.94,5.78 -12.25,3.37 -4.27,-2.45 -5.82,-7.96 -3.37,-12.22 2.39,-4.18 7.94,-5.83 12.24,-3.41"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path236"
          />
          <path
            d="m 1042.74,1418.77 c -2.44,4.29 -7.94,5.78 -12.25,3.37 -4.27,-2.45 -5.82,-7.96 -3.37,-12.22 2.39,-4.18 7.94,-5.83 12.25,-3.41 4.28,2.43 5.75,8.06 3.37,12.26"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path238"
          />
          <path
            d="m 1005.92,1517.24 c 1.03,-2.56 3.48,-10.42 2.51,-15.95 -1.19,-6.84 -4.15,-11.42 -4.17,-11.45 l 6.85,-4.58 c 0.16,0.25 3.94,5.98 5.44,14.63 1.55,8.93 -2.8,19.95 -2.98,20.41 l -7.65,-3.06"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path240"
          />
          <path
            d="m 1141.67,1659.83 c -0.64,0.26 -15.93,6.29 -34.54,1.18 -15.08,-4.13 -20.2,-18.14 -21.84,-25.2 l -11.38,1.22 c 0.28,5.87 -0.11,16.55 -5.53,24.41 -7.51,10.89 -27.19,18.36 -28.02,18.67 l -2.48,0.94 -1.88,-1.88 c -0.53,-0.53 -13.09,-13.19 -17.46,-26.32 -3.23,-9.66 0.04,-19.71 2.45,-25.13 l -10.03,-4.81 c -3.74,3.42 -11.925,9.49 -24.355,11.11 -21.917,2.87 -33.992,-10.39 -34.492,-10.96 l -2.57,-2.9 35.086,-35.08 11.621,-20.78 c 0.156,-2.34 0.262,-5.38 0.121,-9 -0.305,-7.8 -10.043,-34.43 -16.516,-50.42 -3.632,-8.98 -3.222,-18.13 1.133,-25.1 3.051,-4.88 9.395,-10.89 22.302,-11.78 4.79,-0.33 8.89,0.74 12.36,2.64 l -2.81,-8.82 5.57,-9.69 11.7,36.51 c 0.45,1.08 0.83,2.1 1.18,3.07 0.35,-0.44 0.67,-0.88 1.04,-1.32 15.44,-18.4 27.99,-24.86 35.18,-24.86 0.52,0 1.02,0.04 1.49,0.11 2.38,0.33 5.46,1.15 8.89,2.92 l -11.38,-32.47 13.98,-0.88 1.88,8.13 -4.5,0.29 8.24,23.48 c 3.88,-1.77 9.83,-3.5 16.74,-2.12 14.37,2.87 22.21,21.15 21.49,37.16 -0.69,15.26 -11.14,34.65 -12.4,36.92 -0.19,1.33 -0.42,2.7 -0.72,4.18 -1.87,9.38 -1.36,14.79 -0.83,20.52 0.36,3.79 0.68,7.76 0.34,12.74 l 5,25.77 c 2.01,9.65 6.04,18.31 8,23.1 4.37,10.71 19.3,27.71 19.46,27.88 l 3.93,4.37 z m -147.467,-75 c 7.567,5.15 29.887,18.48 60.357,20.07 4.14,0.22 8.22,0.32 12.15,0.32 21.59,0 34.74,-3.29 40.23,-5.05 l -2.92,-15.05 c -5.77,1.56 -16.59,3.85 -30.23,3.85 -4.96,0 -9.95,-0.31 -14.81,-0.92 -22.48,-2.85 -47.91,-13.07 -57.07,-17 z m 28.187,-93.28 c -3.05,-7.18 -8.9,-15.99 -18.54,-15.33 -7.467,0.52 -12.959,3.26 -15.877,7.93 -2.942,4.7 -3.118,11.13 -0.489,17.64 0.68,1.68 16.646,41.25 17.116,53.19 0.12,3.16 0.07,5.92 -0.04,8.24 4.2,1.81 12.98,5.41 23.51,8.89 0.43,-3.37 0.49,-7.62 -0.91,-11.42 -3.3,-8.89 -11.7,-24.73 -11.79,-24.88 l -0.49,-0.94 0.01,-1.07 c 0.02,-0.78 0.44,-16.49 10.37,-33.36 z m 45.44,-17.77 c -2.38,-0.35 -13.23,2.89 -29.2,21.91 -13.04,15.54 -15.13,32.99 -15.45,37.27 1.96,3.74 8.68,16.7 11.7,24.87 2.18,5.89 1.88,12.23 1.16,16.77 7.83,2.3 16.15,4.29 23.98,5.28 4.51,0.57 9.15,0.86 13.77,0.86 13.2,0 23.62,-2.35 28.66,-3.75 0.43,-4.83 0.11,-8.56 -0.25,-12.46 -0.25,-2.62 -0.49,-5.3 -0.52,-8.32 l -20.4,0.31 3.09,-31.4 -10.81,-2.53 8.75,-3.3 7.72,2.96 -4.97,27.06 17.54,-4.58 c 0.16,-0.99 0.33,-2.01 0.55,-3.09 2.67,-13.34 0.78,-17.54 -6.23,-33.16 -1.23,-2.75 -2.62,-5.83 -4.14,-9.34 -8.8,-20.22 -19.4,-24.56 -24.95,-25.36 m 43.21,47.77 c 2.48,-6.21 4.79,-13.53 5.08,-19.77 0.62,-13.83 -6.19,-26.98 -14.89,-28.72 -6.36,-1.28 -11.69,1.37 -13.82,2.66 4.42,4.51 8.92,10.94 12.92,20.14 1.51,3.47 2.88,6.52 4.11,9.25 3.03,6.77 5.26,11.76 6.6,16.44 m 5,106.77 c -2.81,-6.72 -4.54,-10.97 -7.37,-20.05 -6.61,2.04 -20.3,5.19 -41.96,5.19 -4.07,0 -8.3,-0.11 -12.57,-0.34 -32.56,-1.7 -56.062,-15.63 -64.503,-21.42 l -28.422,28.43 c 4.074,2.96 12.281,7.3 24.328,5.72 13.852,-1.8 21.317,-10.48 21.377,-10.55 l 2.05,-2.47 23.47,11.24 -2.36,3.89 c -0.08,0.12 -7.11,12.15 -3.73,22.29 2.84,8.53 10.18,17.32 13.63,21.13 6.18,-2.64 17.28,-8.32 21.62,-14.61 5.83,-8.46 3.8,-22.64 3.77,-22.79 l -0.63,-4.25 27.61,-2.95 0.41,4.13 c 0.02,0.18 1.95,18.16 16.55,22.16 9.5,2.61 18.09,1.79 23.47,0.71 -5.16,-6.23 -13.29,-17.17 -16.74,-25.46"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path242"
          />
          <path
            d="m 1062.41,1502.99 3.95,-1.2 2.4,-4.12 h 18.01 l 1.89,3.09 2.57,1.89 1.03,3.43 -28.82,0.17 -1.03,-3.26"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path244"
          />
          <path
            d="m 1069.96,1556 -27.1,-0.69 4.12,-11.49 21.44,6 1.54,6.18"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path246"
          />
          <path
            d="m 1049.41,1416.53 26.79,0.15 1.91,8.25 -31.55,-0.19 2.85,-8.21"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path248"
          />
          <path
            d="m 1055.86,1397.9 16.08,0.39 1.92,8.29 -20.83,-0.51 2.83,-8.17"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path250"
          />
          <path
            d="m 1043.65,1928.34 c 2.36,-2.25 4.73,-5.3 6.98,-8.92 0.28,-0.46 0.57,-0.94 0.85,-1.42 0.27,-0.46 0.54,-0.93 0.8,-1.4 0.34,-0.61 0.68,-1.22 1.01,-1.86 0.19,-0.36 0.38,-0.73 0.57,-1.1 0.39,-0.78 0.78,-1.58 1.17,-2.4 0.1,-0.23 0.21,-0.47 0.32,-0.71 0.44,-0.96 0.87,-1.93 1.28,-2.94 4.33,-10.39 7.34,-22.75 7.34,-34.59 0,-16.77 -6.41,-26.41 -14.71,-31.06 -2.14,-1.2 -4.41,-2.07 -6.72,-2.64 -0.07,-0.02 -0.14,-0.03 -0.2,-0.05 -0.99,-0.24 -1.99,-0.41 -3,-0.54 -0.23,-0.03 -0.46,-0.07 -0.7,-0.09 -1.08,-0.12 -2.16,-0.19 -3.24,-0.19 -1.08,0 -2.17,0.07 -3.24,0.19 -0.24,0.02 -0.47,0.06 -0.71,0.09 -1,0.13 -2,0.3 -2.99,0.54 -0.07,0.02 -0.14,0.03 -0.21,0.05 -2.31,0.57 -4.58,1.44 -6.71,2.64 -8.31,4.65 -14.71,14.29 -14.71,31.06 0,11.84 3.01,24.2 7.33,34.59 0.41,1 0.85,1.98 1.29,2.95 0.11,0.23 0.21,0.46 0.32,0.7 0.38,0.82 0.78,1.62 1.17,2.41 0.19,0.37 0.37,0.73 0.56,1.09 0.33,0.63 0.67,1.25 1.01,1.86 0.27,0.47 0.54,0.94 0.8,1.4 0.29,0.48 0.57,0.96 0.86,1.41 2.25,3.62 4.62,6.68 6.97,8.93 -278.941,-4.44 -504.507,-232.69 -504.507,-512.67 0,-133.84 51.562,-255.85 135.847,-347.26 v -26.08 h 52.711 c -3.621,-4.43 -5.8,-10.09 -5.8,-16.25 0,-14.19 11.543,-25.73 25.73,-25.73 1.313,0 2.594,0.12 3.856,0.31 83.39,-60.59 185.648,-96.691 296.163,-97.66 v 20.578 c -0.01,0 -0.01,0.012 -0.02,0.012 -2.76,3.101 -19.08,21.949 -23.06,37.871 -3.52,14.09 0.95,27.348 13.12,39.519 4.71,-0.07 9.45,-0.12 14.22,-0.12 4.77,0 9.5,0.05 14.22,0.12 12.16,-12.171 16.64,-25.429 13.11,-39.519 -3.97,-15.902 -20.32,-34.813 -23.06,-37.891 h -0.01 v -20.582 c 110.7,0.84 213.12,36.942 296.64,97.602 1.11,-0.14 2.23,-0.24 3.37,-0.24 14.19,0 25.74,11.54 25.74,25.73 0,6.16 -2.18,11.82 -5.81,16.25 h 52.72 v 26.09 c 84.28,91.4 135.84,213.41 135.84,347.25 0,279.98 -225.56,508.23 -504.51,512.67 M 1072.2,1873 c 0,10.85 -2.44,22.81 -6.4,33.66 152.13,-13.84 277.96,-130.27 301.53,-282.85 h -66.81 c -22.9,118.4 -120.58,205.98 -239.13,217.24 6.4,6.8 10.81,17.1 10.81,31.95 m 227.72,-407.06 h 79.6 v -340.36 h -79.6 z m 79.6,-369.18 h -79.6 v 16.47 h 79.6 z m -79.6,398 h 79.6 v -16.47 h -79.6 z m -12.35,12.35 h -2.56 v 29.72 h 109.43 v -29.72 h -2.57 z m 100.83,42.07 h -21.08 c 3.37,3.99 7.51,9.69 10.54,16.56 3.03,-6.87 7.17,-12.57 10.54,-16.56 m -6.28,32.55 h 10.69 v -24.91 c -4.63,5.98 -9.96,14.96 -10.69,24.91 m -23.33,-29.76 c -4.7,5.06 -13.9,16.54 -14.86,29.76 h 29.71 c -0.96,-13.22 -10.15,-24.7 -14.85,-29.76 m -8.53,-2.79 h -21.08 c 3.36,3.99 7.51,9.69 10.54,16.56 3.03,-6.87 7.17,-12.57 10.54,-16.56 m -29.61,2.79 c -4.71,5.06 -13.9,16.54 -14.86,29.76 h 29.72 c -0.97,-13.22 -10.16,-24.7 -14.86,-29.76 m -8.53,-2.79 h -21.09 c 3.38,3.99 7.51,9.69 10.54,16.56 3.04,-6.87 7.18,-12.57 10.55,-16.56 m -25.49,7.64 v 24.91 h 10.68 c -0.72,-9.95 -6.06,-18.93 -10.68,-24.91 m -1.62,54.64 h 109.43 v -17.37 h -109.43 z m -249.61,218.51 c 123.29,0 228.2,-86.23 252.53,-206.16 h -8.13 c -5.38,16.88 -21.14,29.16 -39.79,29.16 -12.57,0 -61.18,-12.8 -99.75,-23.53 -2.22,-3.24 -4.13,-6.36 -5.1,-8.73 l -0.58,-1.39 c 43.38,12.18 93.68,25.41 105.43,25.41 15.85,0 29.12,-11.04 32.65,-25.82 v -37.18 h 5.73 v -32.55 h -5.73 v -54.42 h 14.91 v -398 h -11.65 c -9.53,6.1 -21.74,11.7 -36.07,16.72 1.54,12.49 19.16,156.24 19.82,224.1 0.06,7.1 0.13,15.42 0.2,24.57 h -8.24 c -0.06,-9.11 -0.13,-17.4 -0.2,-24.48 -0.63,-65.27 -17.14,-201.84 -19.56,-221.52 -7.33,2.33 -15.13,4.53 -23.39,6.58 5.37,34.78 23.32,154.18 25.91,214.36 0.31,7.22 0.66,15.71 1.05,25.06 h -8.25 c -0.37,-9.19 -0.72,-17.55 -1.03,-24.66 -2.56,-59.44 -20.28,-177.55 -25.73,-212.84 -17.67,4.02 -37.21,7.35 -58.02,9.95 -3.16,10.42 -6.46,19.06 -8.47,24 2.98,0.81 4.61,1.56 4.94,1.72 l 2.11,1.06 0.16,2.36 c 0.1,1.64 2.49,40.44 -10.11,69.33 -0.9,2.05 -1.8,4.02 -2.69,5.95 2.82,-0.87 5.91,-1.52 9.11,-1.52 1.93,0 3.89,0.23 5.82,0.76 16.39,4.53 28.09,32.38 38.3,61.81 7.31,21.04 11.79,35.79 13.06,40.06 1.05,-0.34 2.03,-0.66 2.86,-0.93 6.55,-2.18 12.7,0.74 14.94,7.11 2.11,5.91 0.23,13.55 -6.53,16.09 -0.87,0.33 -2.03,0.72 -3.37,1.17 0.45,1.95 2.42,6.81 11.06,11.41 10.98,5.86 17.14,5.47 24.94,4.97 2.4,-0.15 4.88,-0.3 7.6,-0.3 10.36,0 15.38,6.22 17.19,11.49 h 3.83 v 145.13 l -22.56,19.9 -105.68,0.01 v -140.64 l 16.9,-24.45 7.78,0.01 c -1.01,-1.26 -2.14,-2.63 -3.44,-4.14 -6.66,-7.77 -3.97,-15.28 -1.61,-18.16 l 0.82,-1 1.25,-0.35 c 0.34,-0.1 34.41,-9.76 42.39,-12.76 2.12,-0.79 2.33,-3.78 1.68,-5.64 -1.13,-3.19 -3.74,-2.33 -4.59,-2.04 -10.73,3.58 -42.49,13.32 -42.81,13.42 l -1.54,0.46 -1.44,-0.69 c -0.14,-0.06 -1.19,-0.57 -2.9,-1.55 -1.51,10.21 -5.62,34.05 -11.87,40.78 -4.37,4.7 -9.46,7.95 -12.91,9.85 2.66,7.77 3.66,15.55 -4,20.49 -6.66,4.29 -17.19,8.56 -20.89,10 -0.18,0.56 -0.42,1.11 -0.72,1.64 -2.44,4.29 -7.93,5.78 -12.24,3.38 -4.28,-2.46 -5.83,-7.96 -3.38,-12.23 2.4,-4.18 7.95,-5.82 12.25,-3.41 1.06,0.6 1.95,1.4 2.65,2.33 4.3,-1.73 12.64,-5.27 17.86,-8.63 3.55,-2.29 2.75,-6.05 -1.62,-16.97 l -0.83,-2.07 c -3.47,-8.79 -7.26,-16.87 -9.06,-20.63 l -117.146,-2.85 -20.93,53.78 c 3.434,2.09 6.785,3.78 14.082,6.22 0.649,0.22 1.305,0.43 1.957,0.63 l 15.737,-44.4 26.82,0.65 -2.68,8.17 -18.38,-0.44 -13.563,38.28 c 1.969,0.51 3.848,0.97 5.555,1.36 2.748,-2.93 7.338,-3.86 11.028,-1.79 4.28,2.43 5.75,8.06 3.37,12.26 -2.44,4.29 -7.93,5.78 -12.24,3.38 -2.276,-1.31 -3.748,-3.49 -4.291,-5.88 -4.602,-1.07 -10.367,-2.56 -15.914,-4.41 -12.004,-4 -18.438,-8.68 -18.84,-8.96 l -2.617,-1.82 25.222,-65.4 58.13,1.42 c -0.97,-2.45 -0.92,-5.28 0.48,-7.73 2.39,-4.17 7.94,-5.82 12.25,-3.4 4.04,2.29 5.53,7.43 3.69,11.53 l 16.75,0.41 c -0.68,-2.27 -0.5,-4.79 0.76,-6.99 2.39,-4.18 7.94,-5.82 12.25,-3.41 3.81,2.16 5.37,6.84 4.01,10.81 l 9.65,0.23 c 3.23,-4.12 8.69,-12.39 9,-19.06 0.5,-10.33 -3.67,-25.26 -7.83,-34.06 -1.37,-2.89 -2.35,-4.9 -3.05,-6.3 -9.75,1.62 -35.99,5.57 -60.66,5.57 -10.91,0 -24.62,-1.24 -40.727,-3.64 l -78.312,205.64 c 0.285,7.59 2.258,16.67 6.969,19.57 8.328,5.13 17.742,6.06 17.836,6.08 l 7.285,0.68 -4.36,5.87 c -0.429,0.58 -10.679,14.12 -24.886,10.5 -4.692,-1.19 -8.27,-3.35 -10.965,-5.72 -0.981,3.58 -2.832,7.29 -6.238,10.14 -8.235,6.87 -17.457,8.57 -17.844,8.64 l -1.059,0.18 -0.015,0.06 -0.039,-0.05 -0.051,0.01 0.015,-0.05 -0.691,-0.82 c -0.258,-0.3 -6.266,-7.5 -8.215,-18.04 -0.805,-4.37 0.141,-8.41 1.672,-11.79 -3.582,0.1 -7.719,-0.51 -12.09,-2.59 -13.238,-6.3 -12.484,-23.26 -12.441,-23.98 l 0.39,-7.31 6.051,4.13 c 0.078,0.05 7.914,5.35 17.602,6.72 5.461,0.77 12.75,-4.92 17.816,-10.56 l 35.922,-94.33 c -4.723,-2.23 -12.211,-6.8 -20.215,-15.81 -12.734,-14.33 -18.078,-29.04 -18.297,-29.65 l -1.527,-4.28 4.406,-1.11 c 0.039,-0.01 0.711,-0.17 1.774,-0.45 -0.918,-2.97 -2.633,-7.8 -5.844,-15.28 -3.051,-7.1 -7.109,-11.31 -11.813,-16.19 -6.629,-6.87 -14.144,-14.66 -19.957,-31.9 -7.812,-23.15 1.524,-42.47 1.926,-43.28 l 1.543,-3.12 3.328,1 c 0.137,0.04 2.746,0.82 6.969,2.09 5.023,-6.83 19.16,-23.64 40.473,-29.72 2.968,-0.85 5.675,-1.56 8.23,-2.19 -2.187,-6.15 -7.875,-22.43 -9.59,-30.58 -2.09,-9.93 -3.613,-30.05 -3.679,-30.91 l -0.149,-1.98 1.457,-1.35 c 0.102,-0.09 0.988,-0.85 2.485,-1.87 -3.082,-7.21 -8.524,-20.8 -11.379,-32.77 -11.434,-1.88 -22.368,-3.99 -32.668,-6.34 -5.446,35.27 -23.176,153.42 -25.735,212.86 -2.086,48.38 -6.004,151.48 -8.265,211.65 h -8.239 c 2.262,-60.13 6.192,-163.56 8.278,-212.05 2.59,-60.18 20.535,-179.59 25.914,-214.37 -8.258,-2.04 -16.067,-4.24 -23.395,-6.57 -2.422,19.69 -18.933,156.25 -19.562,221.52 -0.469,48.34 -0.938,151.21 -1.192,211.47 h -8.234 c 0.254,-60.27 0.723,-163.19 1.191,-211.56 0.653,-67.85 18.27,-211.59 19.817,-224.09 -14.328,-5.03 -26.524,-10.63 -36.043,-16.73 h -11.656 v 398 h 14.914 v 54.42 h -5.739 v 32.55 h 5.739 v 37.17 c 3.523,14.79 16.789,25.83 32.64,25.83 11.473,0 59.653,-12.6 102.285,-24.53 l 6.063,6.83 c -39.574,11.13 -94.816,25.94 -108.348,25.94 -18.64,0 -34.398,-12.28 -39.789,-29.16 h -8.125 c 24.328,119.93 129.231,206.16 252.533,206.16 M 896.598,1084.04 c 0.211,-0.33 5.449,-8.14 18.777,-11.04 10.039,-2.18 20.215,-0.64 24.262,0.16 3.812,-2.37 14.16,-8.16 26.086,-9.48 11.914,-1.33 23.597,2.18 27.992,3.72 3.723,-1.74 12.955,-5.3 25.985,-5.3 12.91,0 21.55,3.81 25.17,5.78 5.25,-1.7 20.34,-5.98 35.02,-4.2 13.89,1.69 24.18,7.23 28.29,9.77 3.56,-1.27 11,-3.28 19.66,-2.04 11.8,1.69 20.69,8.81 21.06,9.12 l 1.63,1.32 -0.12,2.1 c -0.05,0.98 -1.19,20.62 -4.68,37.7 47.97,-6.37 88.43,-16.77 114.04,-29.86 -43.69,-22.35 -130.5,-36.89 -224.37,-36.89 -93.877,0 -180.677,14.54 -224.369,36.89 21.09,10.78 52.25,19.74 89.391,26.13 -2.57,-14.86 -4.379,-30.34 -4.473,-31.15 l -0.172,-1.48 z m -10.547,474.49 c 0.855,4.62 2.73,8.48 4.234,11.01 2.778,-0.99 6.68,-2.76 10.289,-5.77 5.571,-4.64 4.141,-14.53 4.129,-14.61 l 7.945,-2.02 c 0.028,0.08 2.997,8.15 12.434,10.57 4.188,1.06 8.043,-0.54 10.941,-2.52 -3.855,-1.07 -8.601,-2.82 -13.164,-5.63 -8.191,-5.05 -10.265,-17.29 -10.761,-24.2 -1.203,-0.52 -3.032,-1.23 -5.133,-2.02 -2.125,-0.74 -3.988,-1.35 -5.246,-1.72 -4.793,4.99 -14.203,13.09 -23.739,11.74 -5.3,-0.75 -10.07,-2.43 -13.718,-4.07 0.961,3.37 2.91,7.06 6.808,8.92 8.809,4.17 16.243,-0.14 16.317,-0.19 l 4.824,6.63 c -0.066,0.06 -7.473,6.75 -6.16,13.88 m 23.676,-42.99 v 0 c 0.015,0 0.031,0.01 0.043,0.01 0.019,0.01 0.035,0.01 0.05,0.02 h -0.004 c 1.489,0.56 2.747,1.05 3.836,1.49 l 3.106,-8.15 c -1.633,-0.14 -3.309,-0.5 -4.738,-1.29 -0.981,-0.54 -1.926,-1.27 -2.805,-2.04 l -3.305,8.69 c 1.11,0.35 2.344,0.75 3.817,1.27 m 6.289,-15.12 c 0.656,0.37 2.273,0.4 3.879,0.25 l 2.769,-7.26 c -1.434,-0.18 -2.871,-0.53 -4.121,-1.23 -1.164,-0.65 -2.27,-1.54 -3.277,-2.49 l -2.809,7.38 c 1.047,1.26 2.422,2.72 3.559,3.35 m 6.523,-15.44 c 0.563,0.32 1.848,0.38 3.219,0.3 l 94.392,-247.86 -11.02,5.77 -90.591,237.91 c 1.063,1.35 2.691,3.15 4,3.88 m 78.981,-175.51 c 14.93,2.16 27.62,3.27 37.73,3.27 23.51,0 49.21,-3.81 58.99,-5.41 l -2.53,-13.28 c -9.48,2.07 -33.21,6.54 -56.68,5.31 -19.66,-1.04 -28.67,-2.09 -32.63,-2.71 z m 33.59,-124.77 c 1.91,-3.54 3.3,-9.65 4.07,-14.03 -1.21,0.04 -2.65,0.25 -4.18,0.81 -2.54,0.93 -4.86,6.3 -6.4,9.86 -0.77,1.79 -1.5,3.45 -2.22,4.74 -3.1,5.58 -10.68,9.49 -11.53,9.91 l -3.69,-7.36 c 2.35,-1.18 6.62,-4.01 8.03,-6.55 0.6,-1.09 1.2,-2.5 1.85,-4.01 0.3,-0.69 0.61,-1.4 0.92,-2.11 l -0.66,-0.19 c -1.65,1.5 -4.24,3.9 -6.41,6.08 -2.44,2.43 -7.39,5.25 -13.65,8.83 -4.345,2.48 -8.838,5.05 -12.709,7.63 -7.093,4.73 -12.402,15.85 -13.644,18.62 5.59,4.49 22.785,18.57 25.833,21.11 0.06,0.05 0.12,0.12 0.18,0.18 l 26.83,-14.08 c 0.38,-2.04 1.24,-5.21 3.15,-9.36 1.46,-3.15 3.54,-5.65 5.75,-8.31 3.08,-3.7 6.28,-7.54 8.52,-13.97 2.42,-6.98 2.7,-14.08 2.6,-18.2 h -0.87 c -0.9,4.49 -2.35,10.29 -4.51,14.3 -3.93,7.3 -10.97,13.29 -11.26,13.55 l -5.32,-6.29 c 0.06,-0.05 6.15,-5.26 9.32,-11.16 m -67.036,113.36 c 0.664,1.83 1.039,3.76 1.285,5.71 1.821,0.38 4.293,0.88 7.332,1.48 l 5.028,-13.2 -15.168,-3.06 c -1.028,0.72 -2.035,1.43 -2.961,2.05 1.933,1.86 3.461,4.2 4.484,7.02 m -6.445,30.56 c -2.145,1.74 -3.031,2.46 -2.914,6.39 0.019,0.89 0.969,2.74 2.418,4.95 1.683,-1.62 2.972,-2.96 3.816,-3.87 l 8.77,-23.04 c -1.617,-0.31 -3.059,-0.6 -4.301,-0.86 -0.559,5.12 -1.988,9.57 -3.363,11.76 -1.407,2.22 -3.078,3.58 -4.426,4.67 m 23.062,-44.38 8.516,-22.37 c -1.746,0.16 -3.519,0.01 -5.266,-0.55 -2.23,5.48 -6.402,14.6 -11.136,19.34 -0.539,0.54 -1.184,1.09 -1.789,1.63 z m 8.059,-30.53 c 1.777,-0.28 2.973,-1.63 3.66,-2.71 2.305,-3.62 -0.398,-6.16 -0.969,-6.63 -3.113,-2.6 -21.148,-17.37 -26.179,-21.4 -3.633,-2.9 -8.84,-2.48 -10.739,-0.22 -2.164,2.58 -0.609,6.16 -0.097,7.17 6.926,3.9 24.793,18.34 29.472,22.15 1.633,1.27 3.344,1.87 4.852,1.64 m -53.402,149.61 c -0.426,0.25 -0.801,0.49 -1.25,0.75 -3.614,2.05 -6.571,3.47 -8.914,4.46 2.589,1.88 4.859,3.18 6.632,4.06 z m -5.317,-6.41 c 6.157,-3.49 9.457,-6.59 10.805,-8.01 l 13.566,-35.63 c -6.289,4.96 -14.386,10.24 -23.711,13.76 -8.933,3.38 -23.398,7.3 -30.796,9.24 2.359,5.08 7.156,14.04 14.918,22.77 1.085,1.22 2.148,2.32 3.199,3.36 1.617,-0.47 5.621,-1.86 12.019,-5.49 m -27.047,-29.99 c 1.996,-0.54 4.176,-1.14 6.438,-1.78 0.664,-4.45 0.871,-13.74 -5.445,-25.6 -9.387,-17.62 -24.84,-32.88 -24.993,-33.03 l 5.766,-5.88 c 0.664,0.66 16.492,16.28 26.496,35.04 5.945,11.16 6.945,20.68 6.656,26.97 3.614,-1.12 7.063,-2.25 9.875,-3.32 9.172,-3.46 17.157,-8.94 23.129,-13.84 -2.289,-3.33 -4.34,-7.14 -4.429,-10.24 -0.227,-8 3.347,-10.9 5.961,-13.01 1.101,-0.9 1.968,-1.6 2.648,-2.68 1.559,-2.47 3.644,-12.08 1.25,-18.68 -1.109,-3.04 -2.977,-4.94 -5.719,-5.82 -11.722,-3.76 -69.984,-21.27 -85.168,-25.83 -2.004,5.87 -5.219,19.06 -0.25,33.8 5.227,15.48 11.766,22.26 18.086,28.82 4.828,5 9.813,10.16 13.449,18.65 3.36,7.82 5.215,13.04 6.25,16.43 m -5.226,-96.58 c 2.137,-3.84 6.355,-10.42 12.41,-15.34 8.621,-7.01 21.621,-12.25 22.172,-12.47 l 3.058,7.64 c -0.125,0.05 -12.402,5.01 -20.035,11.21 -4.289,3.49 -7.508,8.11 -9.488,11.41 18.309,5.52 37.418,11.32 45.434,13.83 3.324,-2.11 11.195,-7.31 15.671,-11.79 3.758,-3.75 7.754,-12.61 9.852,-17.89 -11.598,-9.39 -24.324,-19.08 -26.992,-20.15 -4.719,-1.88 -12.656,-2.91 -35.945,3.74 -16.645,4.76 -28.665,17.4 -34.258,24.36 5.269,1.58 11.515,3.46 18.121,5.45 m 43.808,-43.19 c 1.34,0 2.559,0.06 3.688,0.17 -0.293,-3.18 0.32,-6.72 2.953,-9.86 1.609,-1.92 3.813,-3.19 6.238,-3.95 -0.683,-3.11 -1.496,-7.65 -2.035,-13.5 -1.031,-11.24 -1.043,-21.67 -1.043,-22.11 h 8.235 c 0,0.1 0.011,10.51 1.011,21.36 0.594,6.42 1.539,11.12 2.188,13.83 0.238,0.04 0.472,0.11 0.707,0.17 1.715,-3.79 7.722,-15.98 16.453,-21.8 4.105,-2.74 8.937,-5.49 13.195,-7.93 5.034,-2.87 10.254,-5.85 11.914,-7.51 3.65,-3.65 8.21,-7.71 8.41,-7.88 l 1.66,-1.49 6.98,1.9 c 1.61,-2.12 3.56,-3.9 6.07,-4.81 2.78,-1.01 5.36,-1.33 7.48,-1.33 3.06,0 5.16,0.66 5.52,0.78 l 3.18,1.06 -0.21,1.81 h 7.06 l 0.47,3.59 c 0.07,0.52 1.62,12.95 -2.77,25.56 -2.73,7.85 -6.74,12.66 -9.96,16.53 -1.93,2.32 -3.6,4.33 -4.6,6.49 -2.56,5.53 -2.7,8.56 -2.71,8.56 v 2.49 l -4.49,2.36 -21.76,57.13 c 3.64,0.49 10.75,1.23 23.83,2.01 1.84,-4.03 6.57,-15.19 8.12,-26.46 1.99,-14.42 1.51,-36.18 1.51,-36.4 l 8.23,-0.19 c 0.02,0.91 0.5,22.63 -1.58,37.71 -1.42,10.27 -5.09,20.13 -7.47,25.78 6.71,0.22 13.45,-0.01 19.82,-0.51 2.94,-5.46 13.62,-26.28 19.19,-49.44 6.52,-27.07 8.11,-64.7 8.13,-65.08 l 8.23,0.34 c -0.07,1.57 -1.64,38.8 -8.35,66.66 -4.75,19.74 -12.83,37.42 -17.4,46.53 15,-1.83 26.1,-4.59 26.28,-4.65 l 4.24,-1.07 5.39,28.3 c 0.73,1.5 1.65,3.4 2.82,5.88 4.72,9.95 9.19,26.19 8.63,37.99 -0.32,6.8 -4.03,13.9 -7.3,18.9 h 0.1 l 1.11,2.22 c 0.22,0.45 5.54,11.11 10.44,23.48 l 0.28,0.72 c 2.84,-1.64 6.62,-4.18 9.86,-7.66 3.99,-4.31 8.4,-25.95 10.25,-39.95 l 0.28,0.04 c -4.1,-2.88 -9.11,-6.81 -14.48,-11.96 -11.7,-11.23 -13.95,-13.9 -14.28,-14.32 l 6.43,-5.14 c 0.08,0.1 2.19,2.61 13.54,13.52 9.59,9.2 18.04,14.27 21.24,16.04 2.91,-0.9 9.39,-2.9 16.53,-5.11 -1.81,-6.29 -15.01,-32.67 -22.75,-42.16 -9.69,-11.87 -17.26,-17.48 -17.42,-17.61 l 5.47,-6.16 c 0.63,0.56 8.22,6.17 18.33,18.57 8.7,10.66 22.24,37.94 24.24,44.91 2.02,-0.64 4.01,-1.26 5.91,-1.86 -1.18,-3.96 -5.64,-18.67 -12.99,-39.87 -4.99,-14.38 -18.24,-52.57 -32.72,-56.57 -6.89,-1.9 -15.18,2.37 -18.38,4.24 -9.24,17.71 -17.01,27.76 -17.42,28.29 l -6.49,-5.06 c 0.12,-0.16 12.72,-16.46 24.68,-43.89 10,-22.91 9.86,-53.75 9.56,-62.86 -2.71,-0.85 -8.02,-2.1 -16.23,-2.4 -11.65,-0.45 -15.63,1.43 -15.68,1.44 l -2.38,1.42 -2.24,-1.6 c -0.13,-0.1 -13.22,-9.12 -58.51,-11.56 -45.953,-2.46 -72.195,11.22 -72.453,11.36 l -1.375,0.73 -1.508,-0.35 c -0.148,-0.04 -14.855,-3.4 -27.258,-1.49 -8.445,1.31 -13.949,4.41 -16.418,6.08 0.457,5.54 1.762,20.06 3.352,27.6 1.695,8.05 7.867,25.54 9.64,30.5 5.606,-1.06 10.032,-1.5 13.586,-1.5 m -23.875,-67.31 c 3.325,-1.41 7.442,-2.73 12.461,-3.51 11.7,-1.8 24.582,0.42 28.903,1.29 5.64,-2.68 27.715,-11.94 63.735,-11.94 3.73,0 7.62,0.1 11.66,0.32 38.8,2.09 55.45,8.98 60.87,11.89 2.84,-0.91 8.28,-1.95 17.8,-1.6 3.26,0.12 6.08,0.39 8.58,0.72 2,-4.87 6.26,-15.69 9.95,-28.62 4.13,-14.45 5.91,-35.78 6.39,-42.67 -2.7,-1.82 -8.47,-5.18 -15.37,-6.16 -6.76,-0.96 -12.66,0.61 -15.46,1.56 l -8.52,60.59 -8.15,-1.15 8.51,-60.58 c -3.88,-2.3 -12.61,-6.73 -24.15,-8.13 -11.78,-1.43 -24.37,1.72 -30.02,3.42 l -3.71,59.94 -8.22,-0.52 3.7,-59.71 c -2.85,-1.52 -10.05,-4.64 -20.95,-4.64 -9.89,0 -17.16,2.33 -20.876,3.84 l 3.976,61.01 -8.226,0.53 -3.945,-60.66 c -3.988,-1.35 -14.117,-4.29 -24.004,-3.21 -9.848,1.1 -18.734,5.94 -22.234,8.06 l 11.668,58.85 -8.075,1.6 -11.789,-59.44 c -4.191,-0.67 -11.808,-1.44 -19.066,0.13 -7.301,1.59 -11.211,4.85 -12.793,6.5 0.711,5.85 3.191,25.29 6.168,39.32 2.402,11.33 7.969,25.36 11.187,32.97 m 224.979,284 c -0.04,0.04 -0.09,0.05 -0.13,0.09 v 68.5 l 9.03,-13.32 v -68.46 z m 8.9,-24.95 v -15.43 l -9.03,12.72 v 16.03 z m -8.9,105.17 c -0.04,0.04 -0.09,0.05 -0.13,0.09 v 18.97 l 9.03,-12.73 v -19.52 z m 4.4,25.93 h 19.94 l 10.41,-13.72 h -20.09 z m 88.9,-50.43 h 18.96 v -72.74 h -18.96 z m 18.96,-100.18 h -18.96 v 19.21 h 18.96 z m -18.96,128.66 h 18.96 v -20.25 h -18.96 z m -0.63,8.23 v 0.01 l -13.91,13.71 h 16.89 l 15.66,-13.72 z m -46.2,-36.71 h 38.59 v -72.74 h -38.59 z m 38.59,-100.18 h -38.59 v 19.21 h 38.59 z m -38.59,128.66 h 38.59 v -20.25 h -38.59 z m 37.84,8.23 h -39.08 v 0.01 l -10.41,13.71 h 35.58 z m -46.08,-28.48 h -21.1 v 20.25 h 21.1 z m 0,-80.97 h -21.1 v 72.74 h 21.1 z m -21.1,-8.23 h 21.1 v -19.21 h -21.1 z m 2.61,-36.99 c 3.53,4.12 6.04,7.37 7.62,9.5 l 79.98,0.04 c -1.37,-1.71 -3.71,-3.26 -7.87,-3.26 -2.53,0 -4.85,0.15 -7.08,0.29 -8.38,0.53 -16.29,1.03 -29.34,-5.92 -10.55,-5.63 -13.95,-12.21 -15.05,-16.2 -10.89,3.34 -25.38,7.49 -30.21,8.87 -0.44,1.22 -0.69,3.6 1.95,6.68 m -475.137,84.34 h 79.602 v -340.36 h -79.602 z m 79.602,-369.18 h -79.602 v 16.47 h 79.602 z m -79.602,398 h 79.602 v -16.47 h -79.602 z m -12.351,12.35 h -2.563 v 29.72 h 109.43 v -29.72 h -2.562 z m 14.012,58.63 c 3.031,-6.87 7.168,-12.57 10.539,-16.56 h -21.082 c 3.371,3.99 7.511,9.69 10.543,16.56 m -14.954,-8.92 v 24.91 h 10.688 c -0.727,-9.95 -6.063,-18.93 -10.688,-24.91 m 19.165,24.91 h 29.714 c -0.961,-13.22 -10.152,-24.7 -14.859,-29.76 -4.699,5.06 -13.895,16.54 -14.855,29.76 m 33.925,-15.99 c 3.032,-6.87 7.172,-12.57 10.543,-16.56 h -21.082 c 3.367,3.99 7.512,9.69 10.539,16.56 m 4.215,15.99 h 29.719 c -0.969,-13.22 -10.16,-24.7 -14.863,-29.76 -4.7,5.06 -13.895,16.54 -14.856,29.76 m 33.93,-15.99 c 3.027,-6.87 7.172,-12.57 10.539,-16.56 h -21.078 c 3.367,3.99 7.508,9.69 10.539,16.56 m 4.258,15.99 h 10.695 v -24.91 c -4.629,5.98 -9.965,14.96 -10.695,24.91 m -97.114,29.73 h 109.43 v -17.37 h -109.43 z m 333.051,229.59 C 890.844,1829.79 793.172,1742.21 770.277,1623.81 h -66.812 c 23.574,152.58 149.398,269.01 301.535,282.85 -3.97,-10.85 -6.402,-22.81 -6.402,-33.66 0,-14.85 4.402,-25.15 10.812,-31.95 M 543.219,1415.67 c 0,214.73 138.234,397.72 330.379,464.79 -95.676,-50.42 -165.926,-144.19 -182.66,-256.65 h -26.926 v -42.08 h 5.734 v -32.55 h -5.734 v -54.42 h 14.91 v -398 h -18.059 c -73.304,85.96 -117.644,197.34 -117.644,318.91 m 127.613,-360.99 v 29.73 h 8.09 104.305 8.089 v -29.73 z m 60.289,-41.98 c -7.379,0 -13.379,6.01 -13.379,13.38 0,7.38 6,13.38 13.379,13.38 7.379,0 13.383,-6 13.383,-13.38 0,-7.37 -6.004,-13.38 -13.383,-13.38 m 22.125,0.3 c 2.277,3.84 3.609,8.3 3.609,13.08 0,6.16 -2.179,11.82 -5.808,16.25 h 48.414 c 7.258,-4.18 15.805,-8.11 25.434,-11.75 -1.215,-4.42 -2.25,-10.23 -1.707,-16.2 2.402,-26.45 17.394,-41.892 66.761,-68.739 -49.328,15.339 -95.332,38.257 -136.703,67.359 m 140.852,-60.25 c -47.106,25.609 -60.59,39.02 -62.711,62.38 -0.41,4.54 0.363,9.05 1.304,12.64 16.793,-5.76 36.461,-10.73 58.301,-14.78 -1.058,-4.82 -1.945,-12.1 -0.316,-19.92 3.929,-18.84 22.328,-42.308 55.254,-58.992 -17.692,4.621 -37.551,10.91 -51.832,18.672 m 81.48,-21.809 c -46.707,14.618 -72.574,43.329 -76.844,63.809 -1.371,6.6 -0.511,12.84 0.387,16.8 16.77,-2.87 34.688,-5.2 53.484,-6.96 -2.453,-6.578 -5.39,-17.41 -3.824,-28.738 2.262,-16.321 14.547,-35.282 37.297,-48.032 -3.144,0.879 -6.605,1.899 -10.5,3.121 m 24.492,28.52 c 3.25,-12.992 13.24,-27.051 19.69,-35.152 -1.44,0.211 -3.11,0.55 -5.03,1.031 -36.25,9.172 -55.148,32.539 -57.792,51.64 -1.504,10.891 2.07,21.629 4.238,26.86 15.844,-1.3 32.265,-2.19 49.074,-2.63 -10.32,-12.819 -13.848,-27.05 -10.18,-41.749 m 35.33,53.749 c -99.509,0 -191.045,16.34 -231.732,41 v 27.5 c 45.402,-24.03 133.551,-39.16 231.732,-39.16 98.17,0 186.32,15.13 231.73,39.15 v -27.5 c -40.7,-24.65 -132.23,-40.99 -231.73,-40.99 m 15.63,-88.901 c 6.46,8.089 16.45,22.16 19.69,35.152 3.68,14.699 0.15,28.93 -10.18,41.749 16.81,0.44 33.24,1.33 49.08,2.63 2.17,-5.231 5.74,-15.969 4.24,-26.86 -2.65,-19.101 -21.54,-42.468 -57.79,-51.64 -1.92,-0.488 -3.6,-0.82 -5.04,-1.031 m 33.69,3.511 c 22.75,12.75 35.03,31.711 37.29,48.032 1.57,11.328 -1.37,22.16 -3.82,28.738 18.8,1.76 36.72,4.1 53.49,6.96 0.91,-3.94 1.76,-10.15 0.38,-16.8 -4.27,-20.48 -30.13,-49.191 -76.84,-63.809 -3.9,-1.222 -7.35,-2.242 -10.5,-3.121 m 40.15,6.258 c 32.93,16.684 51.32,40.152 55.25,58.992 1.63,7.82 0.74,15.1 -0.32,19.92 21.85,4.05 41.51,9.02 58.31,14.78 0.94,-3.59 1.71,-8.1 1.3,-12.64 -2.12,-23.36 -15.6,-36.771 -62.71,-62.38 -14.28,-7.75 -34.13,-14.051 -51.83,-18.672 m 192.86,78.632 c -41.67,-29.241 -88.02,-52.23 -137.72,-67.519 0.2,0.118 0.42,0.219 0.62,0.329 49.55,26.929 64.57,42.378 66.98,68.86 0.54,5.97 -0.49,11.78 -1.71,16.2 9.63,3.64 18.18,7.57 25.44,11.75 h 48.41 c -3.63,-4.43 -5.81,-10.09 -5.81,-16.25 0,-4.9 1.4,-9.47 3.79,-13.37 m 21.94,-0.01 c -7.37,0 -13.38,6.01 -13.38,13.38 0,7.38 6.01,13.38 13.38,13.38 7.38,0 13.39,-6 13.39,-13.38 0,-7.37 -6.01,-13.38 -13.39,-13.38 m 60.29,41.98 h -120.48 v 29.73 h 8.09 104.3 8.09 z m 9.96,42.08 h -18.05 v 398 h 14.92 v 54.42 h -5.74 v 32.55 h 5.74 v 42.08 h -26.93 c -16.74,112.46 -86.99,206.23 -182.67,256.65 192.15,-67.07 330.39,-250.06 330.39,-464.79 0,-121.57 -44.35,-232.95 -117.66,-318.91"
            style={{
              fill: '#706d6e',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path252"
          />
          <path
            d="m 2679.7,2040.4 c -25.52,0 -46.51,-20.95 -46.51,-46.51 0,-25.5 20.99,-46.45 46.51,-46.45 24.61,0 46.5,20.95 46.5,46.45 0,25.56 -21.89,46.51 -46.5,46.51"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path254"
          />
          <path
            d="m 2643.22,1861.35 v -435.77 c 11.86,0.92 23.7,2.76 36.48,2.76 11.84,0 22.8,-1.84 36.46,-2.76 v 435.77 c -13.66,-0.92 -24.62,-2.71 -36.46,-2.71 -12.78,0 -24.62,1.79 -36.48,2.71"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path256"
          />
          <path
            d="m 3144.74,1861.35 -72.93,-196.89 -54.73,-128.52 c -3.58,-8.26 -10.89,-16.44 -17.28,-25.54 -56.5,127.65 -110.32,266.16 -135.82,350.95 -15.52,-0.92 -27.4,-2.71 -40.14,-2.71 -14.56,0 -28.28,1.79 -41.02,2.71 57.44,-126.69 146.8,-349.11 178.68,-435.77 9.09,0.92 18.24,2.76 28.27,2.76 8.23,0 17.26,-1.84 27.31,-2.76 45.64,132.19 136.78,332.74 186.03,435.77 -10.98,-0.92 -20.08,-2.71 -29.2,-2.71 -10.03,0 -20.05,1.79 -29.17,2.71"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path258"
          />
          <path
            d="m 3424.9,1418.32 c 55.59,0 112.11,21.9 156.81,53.79 l 0.93,47.39 c -24.64,-23.7 -72.97,-62.91 -134.95,-62.91 -110.34,0 -165.88,87.54 -157.71,189.62 h 128.53 c 61.05,0 123.08,-0.9 185.12,-2.74 9.07,152.26 -83.91,223.36 -185.12,223.36 -135.77,0 -208.76,-97.55 -208.76,-224.29 0,-141.26 89.39,-224.22 215.15,-224.22 m -6.39,420.25 c 90.23,0 112.15,-79.32 113.97,-158.61 h -242.5 c 5.49,76.57 42.88,158.61 128.53,158.61"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path260"
          />
          <path
            d="m 3742.45,1781.15 -4.59,-10.95 v 91.15 c -13.66,-0.91 -24.59,-2.71 -36.46,-2.71 -12.7,0 -24.64,1.8 -36.43,2.71 v -435.77 c 11.79,0.92 23.73,2.77 36.43,2.77 11.87,0 22.8,-1.85 36.46,-2.77 v 236.13 c 0,49.22 1.82,79.3 33.76,115.79 13.69,15.47 38.28,22.79 58.36,22.79 15.45,0 29.13,-10.95 42.84,-14.58 l 12.72,76.58 c -8.24,3.62 -15.49,4.54 -28.22,4.54 -45.58,0 -84.84,-38.28 -114.87,-85.68"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path262"
          />
          <path
            d="m 3952.65,1762.91 c 0,49.21 37.42,75.67 83,75.67 33.71,0 65.64,-30.09 77.46,-60.16 h 8.19 c 5.49,21.87 12.82,43.72 21.87,64.72 -16.38,10.02 -55.54,23.69 -102.96,23.69 -82.07,0 -148.61,-47.39 -148.61,-134.92 0,-159.54 215.11,-79.27 215.11,-202.37 0,-48.32 -44.63,-82.94 -89.33,-82.94 -42.79,0 -82.97,31.91 -104.8,67.43 h -7.35 c -3.61,-22.78 -11.85,-44.7 -19.12,-66.55 31.97,-19.14 76.57,-29.16 113.96,-29.16 80.23,0 167.69,46.53 167.69,144.03 0,145.86 -215.11,83.86 -215.11,200.56"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path264"
          />
          <path
            d="m 4287.34,2040.4 c -25.5,0 -46.47,-20.95 -46.47,-46.51 0,-25.5 20.97,-46.45 46.47,-46.45 24.59,0 46.49,20.95 46.49,46.45 0,25.56 -21.9,46.51 -46.49,46.51"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path266"
          />
          <path
            d="m 4250.85,1861.35 v -435.77 c 11.92,0.92 23.72,2.76 36.49,2.76 11.87,0 22.82,-1.84 36.49,-2.76 v 435.77 c -13.67,-0.92 -24.62,-2.71 -36.49,-2.71 -12.77,0 -24.57,1.79 -36.49,2.71"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path268"
          />
          <path
            d="m 4533.05,1597.91 v 228.78 h 96.61 c -2.72,9.11 -2.72,21.92 0,34.66 h -96.61 v 118.52 l -72.99,-28.25 v -90.27 h -56.5 c 2.78,-11.84 2.78,-22.78 0,-34.66 h 56.5 v -265.24 c -4.52,-111.2 35.58,-143.13 104.87,-143.13 26.43,0 51.98,7.26 76.57,16.43 v 21.84 c -13.65,-2.71 -27.34,-6.34 -41.02,-6.34 -75.64,0 -67.43,92.03 -67.43,147.66"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path270"
          />
          <path
            d="m 5274.93,1450.25 c -75.67,0 -67.45,92.03 -67.45,147.66 v 228.78 h 96.61 c -2.75,9.11 -2.75,21.92 0,34.66 h -96.61 v 118.52 l -72.95,-28.25 v -90.27 h -56.47 c 2.68,-11.84 2.68,-22.78 0,-34.66 h 56.47 v -265.24 c -4.58,-111.2 35.51,-143.13 104.82,-143.13 26.51,0 51.98,7.26 76.58,16.43 v 21.84 c -13.7,-2.71 -27.36,-6.34 -41,-6.34"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path272"
          />
          <path
            d="m 2531.45,1338.85 c -19.11,-61.99 -92.97,-241.57 -133.99,-339.131 -41.91,95.701 -93.01,247.051 -116.67,339.131 -9.15,-0.92 -16.41,-2.77 -23.7,-2.77 -8.23,0 -16.39,1.85 -23.72,2.77 -30.11,-95.73 -90.24,-258.02 -127.61,-338.21 -43.76,105.73 -83.88,227.89 -115.78,338.21 -15.49,-0.92 -27.34,-2.77 -40.11,-2.77 -13.66,0 -27.34,1.85 -40.12,2.77 49.23,-113.93 107.57,-270.75 161.37,-435.772 8.19,0.934 16.4,2.774 24.62,2.774 8.19,0 15.48,-1.84 24.59,-2.774 43.75,139.492 93.9,272.612 123.99,330.972 33.73,-83.91 88.41,-242.53 112.14,-330.972 8.19,0.934 16.37,2.774 24.59,2.774 7.31,0 14.59,-1.84 24.6,-2.774 56.56,166.832 151.34,372.872 183.25,435.772 -10.91,-0.92 -19.12,-2.77 -28.27,-2.77 -10.93,0 -20.03,1.85 -29.18,2.77"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path274"
          />
          <path
            d="M 2643.11,1338.85 V 903.078 c 11.8,0.934 23.69,2.774 36.47,2.774 11.85,0 22.77,-1.84 36.46,-2.774 v 435.772 c -13.69,-0.92 -24.61,-2.77 -36.46,-2.77 -12.78,0 -24.67,1.85 -36.47,2.77"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path276"
          />
          <path
            d="m 3004.22,1344.29 c -135.82,0 -208.76,-97.52 -208.76,-224.26 0,-141.26 89.3,-224.21 215.08,-224.21 55.69,0 112.18,21.852 156.86,53.789 l 0.93,47.403 c -24.64,-23.711 -72.92,-62.91 -134.96,-62.91 -110.29,0 -165.9,87.508 -157.71,189.578 h 128.56 c 61.05,0 123.06,-0.88 185.03,-2.72 9.14,152.25 -83.84,223.33 -185.03,223.33 m -128.56,-186.87 c 5.47,76.62 42.89,158.62 128.56,158.62 90.23,0 112.13,-79.29 113.94,-158.62 h -242.5"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path278"
          />
          <path
            d="m 3468.53,1344.29 c -64.73,0 -114.9,-32.84 -146.77,-88.42 v 82.98 c -13.68,-0.91 -24.6,-2.77 -36.44,-2.77 -12.8,0 -24.62,1.86 -36.49,2.77 V 903.078 c 11.87,0.934 23.69,2.774 36.49,2.774 11.84,0 22.76,-1.84 36.44,-2.774 v 211.512 c 0,112.12 23.71,182.35 119.43,182.35 85.66,0 101.15,-66.57 101.15,-151.36 V 903.078 c 11.82,0.934 23.73,2.774 36.51,2.774 11.82,0 22.76,-1.84 36.44,-2.774 v 263.492 c 0,120.32 -41.03,177.72 -146.76,177.72"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path280"
          />
          <path
            d="M 5002.41,1500.14 V 1714 c 0,104.15 -52.49,154.86 -149.35,154.86 -54.38,0 -104.13,-20.28 -148.38,-50.71 v -51.59 h 10.16 c 6.45,20.24 42.33,63.58 109.69,63.58 69.08,0 107.83,-39.64 107.83,-107.86 0,-44.23 -24.88,-49.76 -97.71,-61.76 -86.65,-13.8 -170.57,-27.63 -170.57,-132.71 0,-68.26 57.21,-112.45 122.64,-112.45 55.33,0 97.68,19.33 136.42,58.04 l 8.28,8.31 c 7.38,-54.41 47.03,-61.73 94.94,-53.49 10.19,1.86 21.24,6.47 27.69,9.24 v 20.25 c -54.43,-11.95 -51.64,6.46 -51.64,42.43 m -73.78,17.52 c 0,-6.47 -18.4,-22.13 -24.89,-28.6 -17.5,-17.5 -48.82,-34.98 -73.7,-34.98 -56.21,0 -90.32,28.56 -90.32,86.6 0,83.92 94,93.12 156.68,105.12 l 32.23,6.46 v -134.6"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path282"
          />
          <path
            d="m 4745.54,1949.74 c 23.4,0 44.16,19.9 44.16,44.15 0,24.25 -20.76,44.17 -44.16,44.17 -24.25,0 -44.17,-19.92 -44.17,-44.17 0,-24.25 19.92,-44.15 44.17,-44.15"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path284"
          />
          <path
            d="m 4951.6,1949.74 c 23.41,0 44.16,19.9 44.16,44.15 0,24.25 -20.75,44.17 -44.16,44.17 -24.25,0 -44.12,-19.92 -44.12,-44.17 0,-24.25 19.87,-44.15 44.12,-44.15"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path286"
          />
          <path
            d="m 2035.77,1418.32 c 62.99,0 114.44,29.29 143.8,83.52 l 1.14,-76.26 c 11.48,0.92 22.99,2.63 36.46,2.77 11.52,0 22.15,-1.79 36.46,-2.77 v 250.81 c 5.74,89 34.3,143.05 118.27,143.05 85.69,0 101.21,-66.54 101.21,-151.35 v -242.51 c 11.83,0.92 23.69,2.77 36.46,2.77 11.81,0 22.75,-1.85 36.44,-2.77 v 263.49 c 0,120.34 -41.02,177.77 -146.76,177.77 -63.96,0 -113.65,-32.03 -145.62,-86.43 v 80.95 h -1.13 c -13.18,-0.92 -23.81,-2.71 -36.49,-2.71 -12.29,0.09 -23.82,1.84 -36.44,2.71 v -278.27 c -5.28,-58.54 -30.43,-120.1 -110.99,-120.1 -82.04,0 -110.29,56.51 -110.29,152.23 v 246.14 c -13.69,-0.92 -24.62,-2.71 -36.48,-2.71 -12.76,0 -24.6,1.79 -36.45,2.71 v -267.99 c 0,-123.11 50.13,-175.05 150.41,-175.05"
            style={{
              fill: '#1266ac',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none'
            }}
            id="path288"
          />
        </g>
      </g>
    </chakra.svg>
  )
}

export default Logo
